//COMPONENTS START
import React from "react";

import cit from "../../assets/images/icons/ship-icon-white.svg";
import kf from "../../assets/images/icons/ship-icon-white.svg";
//IMGS START
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
//drinks
import bar1_360 from "../../assets/images/gallery/360/home/bar/1.webp";
import bar1_600 from "../../assets/images/gallery/600/home/bar/1.webp";
import bar1_1366 from "../../assets/images/gallery/1366/home/bar/1.webp";
import bar2_360 from "../../assets/images/gallery/360/home/bar/2.webp";
import bar2_600 from "../../assets/images/gallery/600/home/bar/2.webp";
import bar2_1366 from "../../assets/images/gallery/1366/home/bar/2.webp";

import bar5_360 from "../../assets/images/gallery/360/home/bar/5.webp";
import bar5_600 from "../../assets/images/gallery/600/home/bar/5.webp";
import bar5_1366 from "../../assets/images/gallery/1366/home/bar/5.webp";

import bar7_360 from "../../assets/images/gallery/360/home/bar/7.webp";
import bar7_600 from "../../assets/images/gallery/600/home/bar/7.webp";
import bar7_1366 from "../../assets/images/gallery/1366/home/bar/7.webp";
import bar8_360 from "../../assets/images/gallery/360/home/bar/8.webp";
import bar8_600 from "../../assets/images/gallery/600/home/bar/8.webp";
import bar8_1366 from "../../assets/images/gallery/1366/home/bar/8.webp";
import bar9_360 from "../../assets/images/gallery/360/home/bar/9.webp";
import bar9_600 from "../../assets/images/gallery/600/home/bar/9.webp";
import bar9_1366 from "../../assets/images/gallery/1366/home/bar/9.webp";
import bar10_360 from "../../assets/images/gallery/360/home/bar/10.webp";
import bar10_600 from "../../assets/images/gallery/600/home/bar/10.webp";
import bar10_1366 from "../../assets/images/gallery/1366/home/bar/10.webp";

import bar17_360 from "../../assets/images/gallery/360/home/bar/17.webp";
import bar17_600 from "../../assets/images/gallery/600/home/bar/17.webp";
import bar17_1366 from "../../assets/images/gallery/1366/home/bar/17.webp";
import bar18_360 from "../../assets/images/gallery/360/home/bar/18.webp";
import bar18_600 from "../../assets/images/gallery/600/home/bar/18.webp";
import bar18_1366 from "../../assets/images/gallery/1366/home/bar/18.webp";
//gallery

import gallery44_360 from "../../assets/images/gallery/360/home/gallery/44.webp";
import gallery44_600 from "../../assets/images/gallery/600/home/gallery/44.webp";
import gallery44_1024 from "../../assets/images/gallery/1366/home/gallery/44.webp";
import gallery19_360 from "../../assets/images/gallery/360/home/gallery/19.webp";
import gallery19_600 from "../../assets/images/gallery/600/home/gallery/19.webp";
import gallery19_1366 from "../../assets/images/gallery/1366/home/gallery/19.webp";
//day
import day1_360 from "../../assets/images/gallery/360/2023nov/hero.webp";
import day2_360 from "../../assets/images/gallery/360/day/nappali4.webp";
import day3_360 from "../../assets/images/gallery/360/day/daytime-cit3.webp";
import day4_360 from "../../assets/images/gallery/360/2023osz/59.webp";
import day5_360 from "../../assets/images/gallery/360/2023nov/31.webp";
import day6_360 from "../../assets/images/gallery/360/day/nappali3.webp";
import day1_600 from "../../assets/images/gallery/600/2023nov/hero.webp";
import day2_600 from "../../assets/images/gallery/600/day/nappali4.webp";
import day3_600 from "../../assets/images/gallery/600/day/daytime-cit3.webp";
import day4_600 from "../../assets/images/gallery/600/2023osz/59.webp";
import day5_600 from "../../assets/images/gallery/600/2023nov/31.webp";
import day6_600 from "../../assets/images/gallery/600/day/nappali3.webp";
import day1_1366 from "../../assets/images/gallery/1366/2023nov/hero.webp";
import day2_1366 from "../../assets/images/gallery/1366/day/nappali4.webp";
import day3_1366 from "../../assets/images/gallery/1366/day/daytime-cit3.webp";
import day4_1366 from "../../assets/images/gallery/1366/2023osz/59.webp";
import day5_1366 from "../../assets/images/gallery/1366/2023nov/31.webp";
import day6_1366 from "../../assets/images/gallery/1366/day/nappali3.webp";
import day7_1366 from "../../assets/images/gallery/1366/day/daytime-cit2.webp";
import day7_600 from "../../assets/images/gallery/600/day/daytime-cit2.webp";
import day7_360 from "../../assets/images/gallery/360/day/daytime-cit2.webp";

import day8_360 from "../../assets/images/gallery/360/day/daytime-kisf-1.webp";
import day8_600 from "../../assets/images/gallery/600/day/daytime-kisf-1.webp";
import day8_1366 from "../../assets/images/gallery/1366/day/daytime-kisf-1.webp";
import day9_360 from "../../assets/images/gallery/360/day/daytime-kisf-2.webp";
import day9_600 from "../../assets/images/gallery/600/day/daytime-kisf-2.webp";
import day9_1366 from "../../assets/images/gallery/1366/day/daytime-kisf-2.webp";
import day10_360 from "../../assets/images/gallery/360/day/daytime-kisf-3.webp";
import day10_600 from "../../assets/images/gallery/600/day/daytime-kisf-3.webp";
import day10_1366 from "../../assets/images/gallery/1366/day/daytime-kisf-3.webp";

//night
import evening1_360 from "../../assets/images/gallery/360/night/evening1.webp";
import evening1_600 from "../../assets/images/gallery/600/night/evening1.webp";
import evening1_1366 from "../../assets/images/gallery/1366/night/evening1.webp";
import evening2_360 from "../../assets/images/gallery/360/night/evening2.webp";
import evening2_600 from "../../assets/images/gallery/600/night/evening2.webp";
import evening2_1366 from "../../assets/images/gallery/1366/night/evening2.webp";
import evening3_360 from "../../assets/images/gallery/360/night/evening3.webp";
import evening3_600 from "../../assets/images/gallery/600/night/evening3.webp";
import evening3_1366 from "../../assets/images/gallery/1366/night/evening3.webp";

import evening6_360 from "../../assets/images/gallery/360/night/evening6.webp";
import evening6_600 from "../../assets/images/gallery/600/night/evening6.webp";
import evening6_1366 from "../../assets/images/gallery/1366/night/evening6.webp";

import evening7_360 from "../../assets/images/gallery/360/night/kisf-evening1.webp";
import evening7_600 from "../../assets/images/gallery/600/night/kisf-evening1.webp";
import evening7_1366 from "../../assets/images/gallery/1366/night/kisf-evening1.webp";

import night1_360 from "../../assets/images/gallery/360/night/cit-evening1.webp";
import night2_360 from "../../assets/images/gallery/360/night/cit-evening2.webp";
import night3_360 from "../../assets/images/gallery/360/night/cit-evening3.webp";
import night4_360 from "../../assets/images/gallery/360/night/evening5.webp";
import night5_360 from "../../assets/images/gallery/360/night/evening4.webp";
import night6_360 from "../../assets/images/gallery/360/night/evening3.webp";
import night1_600 from "../../assets/images/gallery/600/night/cit-evening1.webp";
import night2_600 from "../../assets/images/gallery/600/night/cit-evening2.webp";
import night3_600 from "../../assets/images/gallery/600/night/cit-evening3.webp";
import night4_600 from "../../assets/images/gallery/600/night/evening5.webp";
import night5_600 from "../../assets/images/gallery/600/night/evening4.webp";
import night6_600 from "../../assets/images/gallery/600/night/evening3.webp";
import night1_1366 from "../../assets/images/gallery/1366/night/cit-evening1.webp";
import night2_1366 from "../../assets/images/gallery/1366/night/cit-evening2.webp";
import night3_1366 from "../../assets/images/gallery/1366/night/cit-evening3.webp";
import night4_1366 from "../../assets/images/gallery/1366/night/evening5.webp";
import night5_1366 from "../../assets/images/gallery/1366/night/evening4.webp";
import night6_1366 from "../../assets/images/gallery/1366/night/evening3.webp";

import osz2_360 from "../../assets/images/gallery/360/2023osz/2.webp";
import osz2_600 from "../../assets/images/gallery/600/2023osz/2.webp";
import osz2_1366 from "../../assets/images/gallery/1366/2023osz/2.webp";
import osz17_360 from "../../assets/images/gallery/360/2023osz/17.webp";
import osz17_600 from "../../assets/images/gallery/600/2023osz/17.webp";
import osz17_1366 from "../../assets/images/gallery/1366/2023osz/17.webp";
import feb10_360 from "../../assets/images/gallery/360/2024feb/10.webp";
import feb10_600 from "../../assets/images/gallery/600/2024feb/10.webp";
import feb10_1366 from "../../assets/images/gallery/1366/2024feb/10.webp";
import feb15_360 from "../../assets/images/gallery/360/2024feb/15.webp";
import feb15_600 from "../../assets/images/gallery/600/2024feb/15.webp";
import feb15_1366 from "../../assets/images/gallery/1366/2024feb/15.webp";
import kf1_600 from "../../assets/images/gallery/600/kisfaludy/8.webp";
import kf2_600 from "../../assets/images/gallery/600/kisfaludy/11.webp";
import kf3_600 from "../../assets/images/gallery/600/kisfaludy/13.webp";
import kf4_600 from "../../assets/images/gallery/600/kisfaludy/6.webp";
import kf5_600 from "../../assets/images/gallery/600/kisfaludy/15.webp";
import kf6_600 from "../../assets/images/gallery/600/kisfaludy/19.webp";
import kf7_600 from "../../assets/images/gallery/600/kisfaludy/16.webp";
import kf8_600 from "../../assets/images/gallery/600/kisfaludy/21.webp";
import kf9_600 from "../../assets/images/gallery/600/kisfaludy/9.webp";
import kf10_600 from "../../assets/images/gallery/600/kisfaludy/17.webp";
import kf11_600 from "../../assets/images/gallery/600/augkisf/18.webp";
import kf12_600 from "../../assets/images/gallery/600/augkisf/6.webp";
import kf15_600 from "../../assets/images/gallery/600/augkisf/13.webp";
import kf17_600 from "../../assets/images/gallery/600/augkisf/17.webp";
import kf19_600 from "../../assets/images/gallery/600/augkisf/19.webp";

import kf1_360 from "../../assets/images/gallery/360/kisfaludy/8.webp";
import kf2_360 from "../../assets/images/gallery/360/kisfaludy/11.webp";
import kf3_360 from "../../assets/images/gallery/360/kisfaludy/13.webp";
import kf4_360 from "../../assets/images/gallery/360/kisfaludy/6.webp";
import kf5_360 from "../../assets/images/gallery/360/kisfaludy/15.webp";
import kf6_360 from "../../assets/images/gallery/360/kisfaludy/19.webp";
import kf7_360 from "../../assets/images/gallery/360/kisfaludy/16.webp";
import kf8_360 from "../../assets/images/gallery/360/kisfaludy/21.webp";
import kf9_360 from "../../assets/images/gallery/360/kisfaludy/9.webp";
import kf10_360 from "../../assets/images/gallery/360/kisfaludy/17.webp";
import kf11_360 from "../../assets/images/gallery/360/augkisf/18.webp";
import kf12_360 from "../../assets/images/gallery/360/augkisf/6.webp";
import kf15_360 from "../../assets/images/gallery/360/augkisf/13.webp";
import kf17_360 from "../../assets/images/gallery/360/augkisf/17.webp";
import kf19_360 from "../../assets/images/gallery/360/augkisf/19.webp";

import kf1_1366 from "../../assets/images/gallery/1366/kisfaludy/8.webp";
import kf2_1366 from "../../assets/images/gallery/1366/kisfaludy/11.webp";
import kf3_1366 from "../../assets/images/gallery/1366/kisfaludy/13.webp";
import kf4_1366 from "../../assets/images/gallery/1366/kisfaludy/6.webp";
import kf5_1366 from "../../assets/images/gallery/1366/kisfaludy/15.webp";
import kf6_1366 from "../../assets/images/gallery/1366/kisfaludy/19.webp";
import kf7_1366 from "../../assets/images/gallery/1366/kisfaludy/16.webp";
import kf8_1366 from "../../assets/images/gallery/1366/kisfaludy/21.webp";
import kf9_1366 from "../../assets/images/gallery/1366/kisfaludy/9.webp";
import kf10_1366 from "../../assets/images/gallery/1366/kisfaludy/17.webp";
import kf11_1366 from "../../assets/images/gallery/1366/augkisf/18.webp";
import kf12_1366 from "../../assets/images/gallery/1366/augkisf/6.webp";
import kf15_1366 from "../../assets/images/gallery/1366/augkisf/13.webp";
import kf17_1366 from "../../assets/images/gallery/1366/augkisf/17.webp";
import kf19_1366 from "../../assets/images/gallery/1366/augkisf/19.webp";

import kf13_1366 from "../../assets/images/gallery/1366/kisfaludy/historical_A.webp";
import kf13_600 from "../../assets/images/gallery/600/kisfaludy/historical_A.webp";
import kf13_360 from "../../assets/images/gallery/360/kisfaludy/historical_A.webp";

import kf14_1366 from "../../assets/images/gallery/1366/kisfaludy/16.webp";
import kf14_600 from "../../assets/images/gallery/600/kisfaludy/16.webp";
import kf14_360 from "../../assets/images/gallery/360/kisfaludy/16.webp";
import nyar2_360 from "../../assets/images/gallery/360/2023nyar/2.webp";
import nyar2_600 from "../../assets/images/gallery/600/2023nyar/2.webp";
import nyar2_1366 from "../../assets/images/gallery/1366/2023nyar/2.webp";
import nyar3_360 from "../../assets/images/gallery/360/2023nyar/3.webp";
import nyar3_600 from "../../assets/images/gallery/600/2023nyar/3.webp";
import nyar3_1366 from "../../assets/images/gallery/1366/2023nyar/3.webp";
import nyar4_360 from "../../assets/images/gallery/360/2023nyar/10.webp";
import nyar4_600 from "../../assets/images/gallery/600/2023nyar/10.webp";
import nyar4_1366 from "../../assets/images/gallery/1366/2023nyar/10.webp";

import tavasz2_360 from "../../assets/images/gallery/360/2024tavasz/2.webp";
import tavasz2_600 from "../../assets/images/gallery/600/2024tavasz/2.webp";
import tavasz2_1366 from "../../assets/images/gallery/1366/2024tavasz/2.webp";
import tavasz4_360 from "../../assets/images/gallery/360/2024tavasz/4.webp";
import tavasz4_600 from "../../assets/images/gallery/600/2024tavasz/4.webp";
import tavasz4_1366 from "../../assets/images/gallery/1366/2024tavasz/4.webp";
import tavasz5_360 from "../../assets/images/gallery/360/2024tavasz/5.webp";
import tavasz5_600 from "../../assets/images/gallery/600/2024tavasz/5.webp";
import tavasz5_1366 from "../../assets/images/gallery/1366/2024tavasz/5.webp";

import tavasz8_360 from "../../assets/images/gallery/360/2024tavasz/8.webp";
import tavasz8_600 from "../../assets/images/gallery/600/2024tavasz/8.webp";
import tavasz8_1366 from "../../assets/images/gallery/1366/2024tavasz/8.webp";

import tavasz10_360 from "../../assets/images/gallery/360/2024tavasz/10.webp";
import tavasz10_600 from "../../assets/images/gallery/600/2024tavasz/10.webp";
import tavasz10_1366 from "../../assets/images/gallery/1366/2024tavasz/10.webp";

import tavasz12_360 from "../../assets/images/gallery/360/2024tavasz/12.webp";
import tavasz12_600 from "../../assets/images/gallery/600/2024tavasz/12.webp";
import tavasz12_1366 from "../../assets/images/gallery/1366/2024tavasz/12.webp";

import tavasz14_360 from "../../assets/images/gallery/360/2024tavasz/14.webp";
import tavasz14_600 from "../../assets/images/gallery/600/2024tavasz/14.webp";
import tavasz14_1366 from "../../assets/images/gallery/1366/2024tavasz/14.webp";

import tavasz17_360 from "../../assets/images/gallery/360/2024tavasz/17.webp";
import tavasz17_600 from "../../assets/images/gallery/600/2024tavasz/17.webp";
import tavasz17_1366 from "../../assets/images/gallery/1366/2024tavasz/17.webp";

import tavasz35_360 from "../../assets/images/gallery/360/2024tavasz/35.webp";
import tavasz35_600 from "../../assets/images/gallery/600/2024tavasz/35.webp";
import tavasz35_1366 from "../../assets/images/gallery/1366/2024tavasz/35.webp";

import tavasz24_360 from "../../assets/images/gallery/360/2024tavasz/24.webp";
import tavasz24_600 from "../../assets/images/gallery/600/2024tavasz/24.webp";
import tavasz24_1366 from "../../assets/images/gallery/1366/2024tavasz/24.webp";
import tavasz29_360 from "../../assets/images/gallery/360/2024tavasz/29.webp";
import tavasz29_600 from "../../assets/images/gallery/600/2024tavasz/29.webp";
import tavasz29_1366 from "../../assets/images/gallery/1366/2024tavasz/29.webp";
import tavasz37_360 from "../../assets/images/gallery/360/2024tavasz/37.webp";
import tavasz37_600 from "../../assets/images/gallery/600/2024tavasz/37.webp";
import tavasz37_1366 from "../../assets/images/gallery/1366/2024tavasz/37.webp";
import tavasz45_360 from "../../assets/images/gallery/360/2024tavasz/45.webp";
import tavasz45_600 from "../../assets/images/gallery/600/2024tavasz/45.webp";
import tavasz45_1366 from "../../assets/images/gallery/1366/2024tavasz/45.webp";
import tavasz41_360 from "../../assets/images/gallery/360/2024tavasz/41.webp";
import tavasz41_600 from "../../assets/images/gallery/600/2024tavasz/41.webp";
import tavasz41_1366 from "../../assets/images/gallery/1366/2024tavasz/41.webp";
import kftavasz1_360 from "../../assets/images/gallery/360/tavaszkf/1.webp";
import kftavasz1_600 from "../../assets/images/gallery/600/tavaszkf/1.webp";
import kftavasz1_1366 from "../../assets/images/gallery/1366/tavaszkf/1.webp";
import kftavasz2_360 from "../../assets/images/gallery/360/tavaszkf/2.webp";
import kftavasz2_600 from "../../assets/images/gallery/600/tavaszkf/2.webp";
import kftavasz2_1366 from "../../assets/images/gallery/1366/tavaszkf/2.webp";
import kftavasz3_360 from "../../assets/images/gallery/360/tavaszkf/3.webp";
import kftavasz3_600 from "../../assets/images/gallery/600/tavaszkf/3.webp";
import kftavasz3_1366 from "../../assets/images/gallery/1366/tavaszkf/3.webp";
import kftavasz4_360 from "../../assets/images/gallery/360/tavaszkf/4.webp";
import kftavasz4_600 from "../../assets/images/gallery/600/tavaszkf/4.webp";
import kftavasz4_1366 from "../../assets/images/gallery/1366/tavaszkf/4.webp";
import kftavasz5_360 from "../../assets/images/gallery/360/tavaszkf/5.webp";
import kftavasz5_600 from "../../assets/images/gallery/600/tavaszkf/5.webp";
import kftavasz5_1366 from "../../assets/images/gallery/1366/tavaszkf/5.webp";
import kftavasz6_360 from "../../assets/images/gallery/360/tavaszkf/6.webp";
import kftavasz6_600 from "../../assets/images/gallery/600/tavaszkf/6.webp";
import kftavasz6_1366 from "../../assets/images/gallery/1366/tavaszkf/6.webp";

import gal1_360 from "../../assets/images/gallery/360/home/gallery/1.webp";
import gal1_600 from "../../assets/images/gallery/600/home/gallery/1.webp";
import gal1_1366 from "../../assets/images/gallery/1366/home/gallery/1.webp";
import gal2_360 from "../../assets/images/gallery/360/home/gallery/2.webp";
import gal2_600 from "../../assets/images/gallery/600/home/gallery/2.webp";
import gal2_1366 from "../../assets/images/gallery/1366/home/gallery/2.webp";
import gal3_360 from "../../assets/images/gallery/360/home/gallery/3.webp";
import gal3_600 from "../../assets/images/gallery/600/home/gallery/3.webp";
import gal3_1366 from "../../assets/images/gallery/1366/home/gallery/3.webp";
import gal4_360 from "../../assets/images/gallery/360/home/gallery/4.webp";
import gal4_600 from "../../assets/images/gallery/600/home/gallery/4.webp";
import gal4_1366 from "../../assets/images/gallery/1366/home/gallery/4.webp";
import gal5_360 from "../../assets/images/gallery/360/augkisf/5.webp";
import gal5_600 from "../../assets/images/gallery/600/augkisf/5.webp";
import gal5_1366 from "../../assets/images/gallery/1366/augkisf/5.webp";
import gal6_360 from "../../assets/images/gallery/360/tavaszkf/7.webp";
import gal6_600 from "../../assets/images/gallery/600/tavaszkf/7.webp";
import gal6_1366 from "../../assets/images/gallery/1366/tavaszkf/7.webp";
import gal7_360 from "../../assets/images/gallery/360/home/gallery/7.webp";
import gal7_600 from "../../assets/images/gallery/600/home/gallery/7.webp";
import gal7_1366 from "../../assets/images/gallery/1366/home/gallery/7.webp";
import gal8_360 from "../../assets/images/gallery/360/home/gallery/8.webp";
import gal8_600 from "../../assets/images/gallery/600/home/gallery/8.webp";
import gal8_1366 from "../../assets/images/gallery/1366/home/gallery/8.webp";
import gal9_360 from "../../assets/images/gallery/360/home/gallery/9.webp";
import gal9_600 from "../../assets/images/gallery/600/home/gallery/9.webp";
import gal9_1366 from "../../assets/images/gallery/1366/home/gallery/9.webp";
import gal10_360 from "../../assets/images/gallery/360/home/gallery/10.webp";
import gal10_600 from "../../assets/images/gallery/600/home/gallery/10.webp";
import gal10_1366 from "../../assets/images/gallery/1366/home/gallery/10.webp";
import gal11_360 from "../../assets/images/gallery/360/home/gallery/11.webp";
import gal11_600 from "../../assets/images/gallery/600/home/gallery/11.webp";
import gal11_1366 from "../../assets/images/gallery/1366/home/gallery/11.webp";
import gal12_360 from "../../assets/images/gallery/360/home/gallery/12.webp";
import gal12_600 from "../../assets/images/gallery/600/home/gallery/12.webp";
import gal12_1366 from "../../assets/images/gallery/1366/home/gallery/12.webp";
import gal13_360 from "../../assets/images/gallery/360/home/gallery/13.webp";
import gal13_600 from "../../assets/images/gallery/600/home/gallery/13.webp";
import gal13_1366 from "../../assets/images/gallery/1366/home/gallery/13.webp";
import gal14_360 from "../../assets/images/gallery/360/home/gallery/14.webp";
import gal14_600 from "../../assets/images/gallery/600/home/gallery/14.webp";
import gal14_1366 from "../../assets/images/gallery/1366/home/gallery/14.webp";
import gal15_360 from "../../assets/images/gallery/360/home/gallery/15.webp";
import gal15_600 from "../../assets/images/gallery/600/home/gallery/15.webp";
import gal15_1366 from "../../assets/images/gallery/1366/home/gallery/15.webp";
import gal16_360 from "../../assets/images/gallery/360/home/gallery/16.webp";
import gal16_600 from "../../assets/images/gallery/600/home/gallery/16.webp";
import gal16_1366 from "../../assets/images/gallery/1366/home/gallery/16.webp";
import gal17_360 from "../../assets/images/gallery/360/home/gallery/17.webp";
import gal17_600 from "../../assets/images/gallery/600/home/gallery/17.webp";
import gal17_1366 from "../../assets/images/gallery/1366/home/gallery/17.webp";
import gal18_360 from "../../assets/images/gallery/360/home/gallery/18.webp";
import gal18_600 from "../../assets/images/gallery/600/home/gallery/18.webp";
import gal18_1366 from "../../assets/images/gallery/1366/home/gallery/18.webp";
import gal19_360 from "../../assets/images/gallery/360/home/gallery/19.webp";
import gal19_600 from "../../assets/images/gallery/600/home/gallery/19.webp";
import gal19_1366 from "../../assets/images/gallery/1366/home/gallery/19.webp";
import gal20_360 from "../../assets/images/gallery/360/home/gallery/20.webp";
import gal20_600 from "../../assets/images/gallery/600/home/gallery/20.webp";
import gal20_1366 from "../../assets/images/gallery/1366/home/gallery/20.webp";
import gal21_360 from "../../assets/images/gallery/360/home/gallery/21.webp";
import gal21_600 from "../../assets/images/gallery/600/home/gallery/21.webp";
import gal21_1366 from "../../assets/images/gallery/1366/home/gallery/21.webp";
import gal22_360 from "../../assets/images/gallery/360/home/gallery/22.webp";
import gal22_600 from "../../assets/images/gallery/600/home/gallery/22.webp";
import gal22_1366 from "../../assets/images/gallery/1366/home/gallery/22.webp";
import gal23_360 from "../../assets/images/gallery/360/home/gallery/23.webp";
import gal23_600 from "../../assets/images/gallery/600/home/gallery/23.webp";
import gal23_1366 from "../../assets/images/gallery/1366/home/gallery/23.webp";
import gal38_360 from "../../assets/images/gallery/360/home/gallery/38.webp";
import gal38_600 from "../../assets/images/gallery/600/home/gallery/38.webp";
import gal38_1366 from "../../assets/images/gallery/1366/home/gallery/38.webp";
import nyar_24_1_360 from "../../assets/images/gallery/360/2024nyar/DSC00018.webp";
import nyar_24_1_600 from "../../assets/images/gallery/600/2024nyar/DSC00018.webp";
import nyar_24_1_1366 from "../../assets/images/gallery/1366/2024nyar/DSC00018.webp";
import nyar_24_2_360 from "../../assets/images/gallery/360/2024nyar/DSC09943.webp";
import nyar_24_2_600 from "../../assets/images/gallery/600/2024nyar/DSC09943.webp";
import nyar_24_2_1366 from "../../assets/images/gallery/1366/2024nyar/DSC09943.webp";
import nyar_24_3_360 from "../../assets/images/gallery/360/2024nyar/DSC09903.webp";
import nyar_24_3_600 from "../../assets/images/gallery/600/2024nyar/DSC09903.webp";
import nyar_24_3_1366 from "../../assets/images/gallery/1366/2024nyar/DSC09903.webp";
import nyar_24_4_360 from "../../assets/images/gallery/360/2024nyar/DSC09827.webp";
import nyar_24_4_600 from "../../assets/images/gallery/600/2024nyar/DSC09827.webp";
import nyar_24_4_1366 from "../../assets/images/gallery/1366/2024nyar/DSC09827.webp";
import nyar_24_5_360 from "../../assets/images/gallery/360/2024nyar/DSC09847.webp";
import nyar_24_5_600 from "../../assets/images/gallery/600/2024nyar/DSC09847.webp";
import nyar_24_5_1366 from "../../assets/images/gallery/1366/2024nyar/DSC09847.webp";
import nyar_24_6_360 from "../../assets/images/gallery/360/2024nyar/DSC00029.webp";
import nyar_24_6_600 from "../../assets/images/gallery/600/2024nyar/DSC00029.webp";
import nyar_24_6_1366 from "../../assets/images/gallery/1366/2024nyar/DSC00029.webp";
import nyar_24_7_360 from "../../assets/images/gallery/360/2024nyar/DA200368.webp";
import nyar_24_7_600 from "../../assets/images/gallery/600/2024nyar/DA200368.webp";
import nyar_24_7_1366 from "../../assets/images/gallery/1366/2024nyar/DA200368.webp";
import nyar_24_8_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5945.webp";
import nyar_24_8_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5945.webp";
import nyar_24_8_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5945.webp";
import nyar_24_9_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5268.webp";
import nyar_24_9_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5268.webp";
import nyar_24_9_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5268.webp";
import nyar_24_10_360 from "../../assets/images/gallery/360/2024nyar/IMG_4952.webp";
import nyar_24_10_600 from "../../assets/images/gallery/600/2024nyar/IMG_4952.webp";
import nyar_24_10_1366 from "../../assets/images/gallery/1366/2024nyar/IMG_4952.webp";

import nyar_24_12_360 from "../../assets/images/gallery/360/2024nyar/DA200978.webp";
import nyar_24_12_600 from "../../assets/images/gallery/600/2024nyar/DA200978.webp";
import nyar_24_12_1366 from "../../assets/images/gallery/1366/2024nyar/DA200978.webp";
import nyar_24_13_360 from "../../assets/images/gallery/360/2024nyar/DA201272.webp";
import nyar_24_13_600 from "../../assets/images/gallery/600/2024nyar/DA201272.webp";
import nyar_24_13_1366 from "../../assets/images/gallery/1366/2024nyar/DA201272.webp";
import nyar_24_14_360 from "../../assets/images/gallery/360/2024nyar/DA201067.webp";
import nyar_24_14_600 from "../../assets/images/gallery/600/2024nyar/DA201067.webp";
import nyar_24_14_1366 from "../../assets/images/gallery/1366/2024nyar/DA201067.webp";
import nyar_24_15_360 from "../../assets/images/gallery/360/2024nyar/DA201332.webp";
import nyar_24_15_600 from "../../assets/images/gallery/600/2024nyar/DA201332.webp";
import nyar_24_15_1366 from "../../assets/images/gallery/1366/2024nyar/DA201332.webp";

import hab1_360 from "../../assets/images/gallery/360/2024nyar/DA201272.webp";
import hab1_600 from "../../assets/images/gallery/600/2024nyar/DA201272.webp";
import hab1_1366 from "../../assets/images/gallery/1366/2024nyar/DA201272.webp";
import hab2_360 from "../../assets/images/gallery/360/2024nyar/DA200821.webp";
import hab2_600 from "../../assets/images/gallery/600/2024nyar/DA200821.webp";
import hab2_1366 from "../../assets/images/gallery/1366/2024nyar/DA200821.webp";
import hab3_360 from "../../assets/images/gallery/360/2024nyar/DA201127.webp";
import hab3_600 from "../../assets/images/gallery/600/2024nyar/DA201127.webp";
import hab3_1366 from "../../assets/images/gallery/1366/2024nyar/DA201127.webp";
import hab4_360 from "../../assets/images/gallery/360/2024nyar/DA200437.webp";
import hab4_600 from "../../assets/images/gallery/600/2024nyar/DA200437.webp";
import hab4_1366 from "../../assets/images/gallery/1366/2024nyar/DA200437.webp";
import hab5_360 from "../../assets/images/gallery/360/2024nyar/DA200622.webp";
import hab5_600 from "../../assets/images/gallery/600/2024nyar/DA200622.webp";
import hab5_1366 from "../../assets/images/gallery/1366/2024nyar/DA200622.webp";
import hab6_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5205.webp";
import hab6_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5205.webp";
import hab6_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5205.webp";
import hab7_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5332.webp";
import hab7_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5332.webp";
import hab7_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5332.webp";
import hab8_360 from "../../assets/images/gallery/360/2024nyar/DA201413.webp";
import hab8_600 from "../../assets/images/gallery/600/2024nyar/DA201413.webp";
import hab8_1366 from "../../assets/images/gallery/1366/2024nyar/DA201413.webp";
import hab10_360 from "../../assets/images/gallery/360/2024nyar/DA200363.webp";
import hab10_600 from "../../assets/images/gallery/600/2024nyar/DA200363.webp";
import hab10_1366 from "../../assets/images/gallery/1366/2024nyar/DA200363.webp";
import hab11_360 from "../../assets/images/gallery/360/2024nyar/DA200398.webp";
import hab11_600 from "../../assets/images/gallery/600/2024nyar/DA200398.webp";
import hab11_1366 from "../../assets/images/gallery/1366/2024nyar/DA200398.webp";
import hab12_360 from "../../assets/images/gallery/360/2024nyar/DA200400.webp";
import hab12_600 from "../../assets/images/gallery/600/2024nyar/DA200400.webp";
import hab12_1366 from "../../assets/images/gallery/1366/2024nyar/DA200400.webp";
import hab13_360 from "../../assets/images/gallery/360/2024nyar/DA200437.webp";
import hab13_600 from "../../assets/images/gallery/600/2024nyar/DA200437.webp";
import hab13_1366 from "../../assets/images/gallery/1366/2024nyar/DA200437.webp";
import hab14_360 from "../../assets/images/gallery/360/2024nyar/DA200440.webp";
import hab14_600 from "../../assets/images/gallery/600/2024nyar/DA200440.webp";
import hab14_1366 from "../../assets/images/gallery/1366/2024nyar/DA200440.webp";
import hab15_360 from "../../assets/images/gallery/360/2024nyar/DA200507.webp";
import hab15_600 from "../../assets/images/gallery/600/2024nyar/DA200507.webp";
import hab15_1366 from "../../assets/images/gallery/1366/2024nyar/DA200507.webp";
import hab16_360 from "../../assets/images/gallery/360/2024nyar/DA200516.webp";
import hab16_600 from "../../assets/images/gallery/600/2024nyar/DA200516.webp";
import hab16_1366 from "../../assets/images/gallery/1366/2024nyar/DA200516.webp";
import hab17_360 from "../../assets/images/gallery/360/2024nyar/DA200525.webp";
import hab17_600 from "../../assets/images/gallery/600/2024nyar/DA200525.webp";
import hab17_1366 from "../../assets/images/gallery/1366/2024nyar/DA200525.webp";
import hab18_360 from "../../assets/images/gallery/360/2024nyar/DA200554.webp";
import hab18_600 from "../../assets/images/gallery/600/2024nyar/DA200554.webp";
import hab18_1366 from "../../assets/images/gallery/1366/2024nyar/DA200554.webp";
import hab19_360 from "../../assets/images/gallery/360/2024nyar/DA200657.webp";
import hab19_600 from "../../assets/images/gallery/600/2024nyar/DA200657.webp";
import hab19_1366 from "../../assets/images/gallery/1366/2024nyar/DA200657.webp";
import hab20_360 from "../../assets/images/gallery/360/2024nyar/DA200978.webp";
import hab20_600 from "../../assets/images/gallery/600/2024nyar/DA200978.webp";
import hab20_1366 from "../../assets/images/gallery/1366/2024nyar/DA200978.webp";

import hab21_360 from "../../assets/images/gallery/360/2024nyar/DA200993.webp";
import hab21_600 from "../../assets/images/gallery/600/2024nyar/DA200993.webp";
import hab21_1366 from "../../assets/images/gallery/1366/2024nyar/DA200993.webp";
import hab22_360 from "../../assets/images/gallery/360/2024nyar/DA201067.webp";
import hab22_600 from "../../assets/images/gallery/600/2024nyar/DA201067.webp";
import hab22_1366 from "../../assets/images/gallery/1366/2024nyar/DA201067.webp";
// import hab23_360 from "../../assets/images/gallery/360/2024nyar/DA201115.webp";
// import hab23_600 from "../../assets/images/gallery/600/2024nyar/DA201115.webp";
// import hab23_1366 from "../../assets/images/gallery/1366/2024nyar/DA201115.webp";
// import hab24_360 from "../../assets/images/gallery/360/2024nyar/DA201118.webp";
// import hab24_600 from "../../assets/images/gallery/600/2024nyar/DA201118.webp";
// import hab24_1366 from "../../assets/images/gallery/1366/2024nyar/DA201118.webp";
import hab25_360 from "../../assets/images/gallery/360/2024nyar/DA201231.webp";
import hab25_600 from "../../assets/images/gallery/600/2024nyar/DA201231.webp";
import hab25_1366 from "../../assets/images/gallery/1366/2024nyar/DA201231.webp";
import hab26_360 from "../../assets/images/gallery/360/2024nyar/DA200516.webp";
import hab26_600 from "../../assets/images/gallery/600/2024nyar/DA200516.webp";
import hab26_1366 from "../../assets/images/gallery/1366/2024nyar/DA200516.webp";
// import hab27_360 from "../../assets/images/gallery/360/2024nyar/DSC04665.webp";
// import hab27_600 from "../../assets/images/gallery/600/2024nyar/DSC04665.webp";
// import hab27_1366 from "../../assets/images/gallery/1366/2024nyar/DSC04665.webp";
import hab28_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5145.webp";
import hab28_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5145.webp";
import hab28_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5145.webp";
import hab29_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5341.webp";
import hab29_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5341.webp";
import hab29_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5341.webp";
import hab30_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5839.webp";
import hab30_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5839.webp";
import hab30_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5839.webp";

import hab31_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5871.webp";
import hab31_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5871.webp";
import hab31_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5871.webp";
import hab32_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5913.webp";
import hab32_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5913.webp";
import hab32_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5913.webp";
import hab33_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5945.webp";
import hab33_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5945.webp";
import hab33_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5945.webp";

import kf30_360 from "../../assets/images/gallery/360/2024nyar/DA201349.webp";
import kf30_600 from "../../assets/images/gallery/600/2024nyar/DA201349.webp";
import kf30_1366 from "../../assets/images/gallery/1366/2024nyar/DA201349.webp";
import kf31_360 from "../../assets/images/gallery/360/2024nyar/DSC06500.webp";
import kf31_600 from "../../assets/images/gallery/600/2024nyar/DSC06500.webp";
import kf31_1366 from "../../assets/images/gallery/1366/2024nyar/DSC06500.webp";
import kf32_360 from "../../assets/images/gallery/360/2024nyar/DA201289.webp";
import kf32_600 from "../../assets/images/gallery/600/2024nyar/DA201289.webp";
import kf32_1366 from "../../assets/images/gallery/1366/2024nyar/DA201289.webp";
import kf33_360 from "../../assets/images/gallery/360/2024nyar/DSC06180.webp";
import kf33_600 from "../../assets/images/gallery/600/2024nyar/DSC06180.webp";
import kf33_1366 from "../../assets/images/gallery/1366/2024nyar/DSC06180.webp";
import ujgal1_360 from "../../assets/images/gallery/360/2024nyar/DunaCruises-0710_BP-5489.webp";
import ujgal1_600 from "../../assets/images/gallery/600/2024nyar/DunaCruises-0710_BP-5489.webp";
import ujgal1_1366 from "../../assets/images/gallery/1366/2024nyar/DunaCruises-0710_BP-5489.webp";

import ujgal10_360 from "../../assets/images/gallery/360/2024nyar/ld-export-c61024db-06302024.webp";
import ujgal10_600 from "../../assets/images/gallery/600/2024nyar/ld-export-c61024db-06302024.webp";
import ujgal10_1366 from "../../assets/images/gallery/1366/2024nyar/ld-export-c61024db-06302024.webp";

import osz24_1_360 from "../../assets/images/gallery/360/2024osz/DSC04621.webp";
import osz24_1_600 from "../../assets/images/gallery/600/2024osz/DSC04621.webp";
import osz24_1_1366 from "../../assets/images/gallery/1366/2024osz/DSC04621.webp";

import osz24_2_360 from "../../assets/images/gallery/360/2024osz/DSC04667-Enhanced-NR.webp";
import osz24_2_600 from "../../assets/images/gallery/600/2024osz/DSC04667-Enhanced-NR.webp";
import osz24_2_1366 from "../../assets/images/gallery/1366/2024osz/DSC04667-Enhanced-NR.webp";
import osz24_3_360 from "../../assets/images/gallery/360/2024osz/DSC06017.webp";
import osz24_3_600 from "../../assets/images/gallery/600/2024osz/DSC06017.webp";
import osz24_3_1366 from "../../assets/images/gallery/1366/2024osz/DSC06017.webp";
import osz24_4_360 from "../../assets/images/gallery/360/2024osz/DSC06027.webp";
import osz24_4_600 from "../../assets/images/gallery/600/2024osz/DSC06027.webp";
import osz24_4_1366 from "../../assets/images/gallery/1366/2024osz/DSC06027.webp";
import osz24_5_360 from "../../assets/images/gallery/360/2024osz/DSC06097.webp";
import osz24_5_600 from "../../assets/images/gallery/600/2024osz/DSC06097.webp";
import osz24_5_1366 from "../../assets/images/gallery/1366/2024osz/DSC06097.webp";
import osz24_6_360 from "../../assets/images/gallery/360/2024osz/DSC06153.webp";
import osz24_6_600 from "../../assets/images/gallery/600/2024osz/DSC06153.webp";
import osz24_6_1366 from "../../assets/images/gallery/1366/2024osz/DSC06153.webp";
import osz24_7_360 from "../../assets/images/gallery/360/2024osz/DSC06164.webp";
import osz24_7_600 from "../../assets/images/gallery/600/2024osz/DSC06164.webp";
import osz24_7_1366 from "../../assets/images/gallery/1366/2024osz/DSC06164.webp";
import osz24_8_360 from "../../assets/images/gallery/360/2024osz/DSC06168.webp";
import osz24_8_600 from "../../assets/images/gallery/600/2024osz/DSC06168.webp";
import osz24_8_1366 from "../../assets/images/gallery/1366/2024osz/DSC06168.webp";
import osz24_9_360 from "../../assets/images/gallery/360/2024osz/DSC06197.webp";
import osz24_9_600 from "../../assets/images/gallery/600/2024osz/DSC06197.webp";
import osz24_9_1366 from "../../assets/images/gallery/1366/2024osz/DSC06197.webp";
import osz24_10_360 from "../../assets/images/gallery/360/2024osz/DSC06319.webp";
import osz24_10_600 from "../../assets/images/gallery/600/2024osz/DSC06319.webp";
import osz24_10_1366 from "../../assets/images/gallery/1366/2024osz/DSC06319.webp";
import osz24_11_360 from "../../assets/images/gallery/360/2024osz/DSC06338.webp";
import osz24_11_600 from "../../assets/images/gallery/600/2024osz/DSC06338.webp";
import osz24_11_1366 from "../../assets/images/gallery/1366/2024osz/DSC06338.webp";
import osz24_12_360 from "../../assets/images/gallery/360/2024osz/DSC06356.webp";
import osz24_12_600 from "../../assets/images/gallery/600/2024osz/DSC06356.webp";
import osz24_12_1366 from "../../assets/images/gallery/1366/2024osz/DSC06356.webp";
import osz24_13_360 from "../../assets/images/gallery/360/2024osz/DSC06389.webp";
import osz24_13_600 from "../../assets/images/gallery/600/2024osz/DSC06389.webp";
import osz24_13_1366 from "../../assets/images/gallery/1366/2024osz/DSC06389.webp";
import osz24_14_360 from "../../assets/images/gallery/360/2024osz/DSC06464.webp";
import osz24_14_600 from "../../assets/images/gallery/600/2024osz/DSC06464.webp";
import osz24_14_1366 from "../../assets/images/gallery/1366/2024osz/DSC06464.webp";
import osz24_15_360 from "../../assets/images/gallery/360/2024osz/DSC07837.webp";
import osz24_15_600 from "../../assets/images/gallery/600/2024osz/DSC07837.webp";
import osz24_15_1366 from "../../assets/images/gallery/1366/2024osz/DSC07837.webp";
import osz24_16_360 from "../../assets/images/gallery/360/2024osz/DSC07852.webp";
import osz24_16_600 from "../../assets/images/gallery/600/2024osz/DSC07852.webp";
import osz24_16_1366 from "../../assets/images/gallery/1366/2024osz/DSC07852.webp";
import osz24_17_360 from "../../assets/images/gallery/360/2024osz/DSC07883.webp";
import osz24_17_600 from "../../assets/images/gallery/600/2024osz/DSC07883.webp";
import osz24_17_1366 from "../../assets/images/gallery/1366/2024osz/DSC07883.webp";
import osz24_18_360 from "../../assets/images/gallery/360/2024osz/DSC07943.webp";
import osz24_18_600 from "../../assets/images/gallery/600/2024osz/DSC07943.webp";
import osz24_18_1366 from "../../assets/images/gallery/1366/2024osz/DSC07943.webp";
import osz24_19_360 from "../../assets/images/gallery/360/2024osz/DSC08038.webp";
import osz24_19_600 from "../../assets/images/gallery/600/2024osz/DSC08038.webp";
import osz24_19_1366 from "../../assets/images/gallery/1366/2024osz/DSC08038.webp";
// import osz24_20_360 from "../../assets/images/gallery/360/2024osz/DSC08069.webp";
// import osz24_20_600 from "../../assets/images/gallery/600/2024osz/DSC08069.webp";
// import osz24_20_1366 from "../../assets/images/gallery/1366/2024osz/DSC08069.webp";
// import osz24_21_360 from "../../assets/images/gallery/360/2024osz/DSC08074.webp";
// import osz24_21_600 from "../../assets/images/gallery/600/2024osz/DSC08074.webp";
// import osz24_21_1366 from "../../assets/images/gallery/1366/2024osz/DSC08074.webp";

import tel24_01_360 from "../../assets/images/gallery/360/2024tel/DSC08778.webp";
import tel24_01_600 from "../../assets/images/gallery/600/2024tel/DSC08778.webp";
import tel24_01_1366 from "../../assets/images/gallery/1366/2024tel/DSC08778.webp";
import tel24_02_360 from "../../assets/images/gallery/360/2024tel/DSC08775.webp";
import tel24_02_600 from "../../assets/images/gallery/600/2024tel/DSC08775.webp";
import tel24_02_1366 from "../../assets/images/gallery/1366/2024tel/DSC08775.webp";
import tel24_03_360 from "../../assets/images/gallery/360/2024tel/DSC08818.webp";
import tel24_03_600 from "../../assets/images/gallery/600/2024tel/DSC08818.webp";
import tel24_03_1366 from "../../assets/images/gallery/1366/2024tel/DSC08818.webp";
import tel24_04_360 from "../../assets/images/gallery/360/2024tel/DSC08772.webp";
import tel24_04_600 from "../../assets/images/gallery/600/2024tel/DSC08772.webp";
import tel24_04_1366 from "../../assets/images/gallery/1366/2024tel/DSC08772.webp";
import tel24_05_360 from "../../assets/images/gallery/360/2024tel/DA201206.webp";
import tel24_05_600 from "../../assets/images/gallery/600/2024tel/DA201206.webp";
import tel24_05_1366 from "../../assets/images/gallery/1366/2024tel/DA201206.webp";
import tel24_06_360 from "../../assets/images/gallery/360/2024tel/DA201209.webp";
import tel24_06_600 from "../../assets/images/gallery/600/2024tel/DA201209.webp";
import tel24_06_1366 from "../../assets/images/gallery/1366/2024tel/DA201209.webp";
import tel24_07_360 from "../../assets/images/gallery/360/2024tel/DA201215.webp";
import tel24_07_600 from "../../assets/images/gallery/600/2024tel/DA201215.webp";
import tel24_07_1366 from "../../assets/images/gallery/1366/2024tel/DA201215.webp";
import tel24_08_360 from "../../assets/images/gallery/360/2024tel/DA201218.webp";
import tel24_08_600 from "../../assets/images/gallery/600/2024tel/DA201218.webp";
import tel24_08_1366 from "../../assets/images/gallery/1366/2024tel/DA201218.webp";
import tel24_09_360 from "../../assets/images/gallery/360/2024tel/DA201337.webp";
import tel24_09_600 from "../../assets/images/gallery/600/2024tel/DA201337.webp";
import tel24_09_1366 from "../../assets/images/gallery/1366/2024tel/DA201337.webp";
import tel24_10_360 from "../../assets/images/gallery/360/2024tel/DA201248.webp";
import tel24_10_600 from "../../assets/images/gallery/600/2024tel/DA201248.webp";
import tel24_10_1366 from "../../assets/images/gallery/1366/2024tel/DA201248.webp";
import tel24_11_360 from "../../assets/images/gallery/360/2024tel/DA201263.webp";
import tel24_11_600 from "../../assets/images/gallery/600/2024tel/DA201263.webp";
import tel24_11_1366 from "../../assets/images/gallery/1366/2024tel/DA201263.webp";
import tel24_12_360 from "../../assets/images/gallery/360/2024tel/DA201291.webp";
import tel24_12_600 from "../../assets/images/gallery/600/2024tel/DA201291.webp";
import tel24_12_1366 from "../../assets/images/gallery/1366/2024tel/DA201291.webp";
import tel24_13_360 from "../../assets/images/gallery/360/2024tel/DA201352.webp";
import tel24_13_600 from "../../assets/images/gallery/600/2024tel/DA201352.webp";
import tel24_13_1366 from "../../assets/images/gallery/1366/2024tel/DA201352.webp";
import tel24_14_360 from "../../assets/images/gallery/360/2024tel/DA201425.webp";
import tel24_14_600 from "../../assets/images/gallery/600/2024tel/DA201425.webp";
import tel24_14_1366 from "../../assets/images/gallery/1366/2024tel/DA201425.webp";
import tel24_15_360 from "../../assets/images/gallery/360/2024tel/DA201548.webp";
import tel24_15_600 from "../../assets/images/gallery/600/2024tel/DA201548.webp";
import tel24_15_1366 from "../../assets/images/gallery/1366/2024tel/DA201548.webp";
import tel24_16_360 from "../../assets/images/gallery/360/2024tel/DA201551.webp";
import tel24_16_600 from "../../assets/images/gallery/600/2024tel/DA201551.webp";
import tel24_16_1366 from "../../assets/images/gallery/1366/2024tel/DA201551.webp";
import tel24_17_360 from "../../assets/images/gallery/360/2024tel/DA201492.webp";
import tel24_17_600 from "../../assets/images/gallery/600/2024tel/DA201492.webp";
import tel24_17_1366 from "../../assets/images/gallery/1366/2024tel/DA201492.webp";

import tel24_18_360 from "../../assets/images/gallery/360/2024tel/DA203349.webp";
import tel24_18_600 from "../../assets/images/gallery/600/2024tel/DA203349.webp";
import tel24_18_1366 from "../../assets/images/gallery/1366/2024tel/DA203349.webp";
import tel24_19_360 from "../../assets/images/gallery/360/2024tel/DA203350.webp";
import tel24_19_600 from "../../assets/images/gallery/600/2024tel/DA203350.webp";
import tel24_19_1366 from "../../assets/images/gallery/1366/2024tel/DA203350.webp";
import tel24_20_360 from "../../assets/images/gallery/360/2024tel/DA203392.webp";
import tel24_20_600 from "../../assets/images/gallery/600/2024tel/DA203392.webp";
import tel24_20_1366 from "../../assets/images/gallery/1366/2024tel/DA203392.webp";
import tel24_21_360 from "../../assets/images/gallery/360/2024tel/DA203410.webp";
import tel24_21_600 from "../../assets/images/gallery/600/2024tel/DA203410.webp";
import tel24_21_1366 from "../../assets/images/gallery/1366/2024tel/DA203410.webp";
import tel24_22_360 from "../../assets/images/gallery/360/2024tel/DA203491.webp";
import tel24_22_600 from "../../assets/images/gallery/600/2024tel/DA203491.webp";
import tel24_22_1366 from "../../assets/images/gallery/1366/2024tel/DA203491.webp";
import tel24_23_360 from "../../assets/images/gallery/360/2024tel/DA203516.webp";
import tel24_23_600 from "../../assets/images/gallery/600/2024tel/DA203516.webp";
import tel24_23_1366 from "../../assets/images/gallery/1366/2024tel/DA203516.webp";
import tel24_24_360 from "../../assets/images/gallery/360/2024tel/DA203566.webp";
import tel24_24_600 from "../../assets/images/gallery/600/2024tel/DA203566.webp";
import tel24_24_1366 from "../../assets/images/gallery/1366/2024tel/DA203566.webp";
import tel24_25_360 from "../../assets/images/gallery/360/2024tel/DA203601.webp";
import tel24_25_600 from "../../assets/images/gallery/600/2024tel/DA203601.webp";
import tel24_25_1366 from "../../assets/images/gallery/1366/2024tel/DA203601.webp";
import tel24_26_360 from "../../assets/images/gallery/360/2024tel/DA203637.webp";
import tel24_26_600 from "../../assets/images/gallery/600/2024tel/DA203637.webp";
import tel24_26_1366 from "../../assets/images/gallery/1366/2024tel/DA203637.webp";
import tel24_27_360 from "../../assets/images/gallery/360/2024tel/DA203723.webp";
import tel24_27_600 from "../../assets/images/gallery/600/2024tel/DA203723.webp";
import tel24_27_1366 from "../../assets/images/gallery/1366/2024tel/DA203723.webp";
import tel24_28_360 from "../../assets/images/gallery/360/2024tel/DA203749.webp";
import tel24_28_600 from "../../assets/images/gallery/600/2024tel/DA203749.webp";
import tel24_28_1366 from "../../assets/images/gallery/1366/2024tel/DA203749.webp";
import tel24_29_360 from "../../assets/images/gallery/360/2024tel/DSC09176.webp";
import tel24_29_600 from "../../assets/images/gallery/600/2024tel/DSC09176.webp";
import tel24_29_1366 from "../../assets/images/gallery/1366/2024tel/DSC09176.webp";
import tel24_30_360 from "../../assets/images/gallery/360/2024tel/DSC09231.webp";
import tel24_30_600 from "../../assets/images/gallery/600/2024tel/DSC09231.webp";
import tel24_30_1366 from "../../assets/images/gallery/1366/2024tel/DSC09231.webp";
import tel24_31_360 from "../../assets/images/gallery/360/2024tel/DSC09267.webp";
import tel24_31_600 from "../../assets/images/gallery/600/2024tel/DSC09267.webp";
import tel24_31_1366 from "../../assets/images/gallery/1366/2024tel/DSC09267.webp";
import tel24_32_360 from "../../assets/images/gallery/360/2024tel/DSC09334.webp";
import tel24_32_600 from "../../assets/images/gallery/600/2024tel/DSC09334.webp";
import tel24_32_1366 from "../../assets/images/gallery/1366/2024tel/DSC09334.webp";
import tel24_33_360 from "../../assets/images/gallery/360/2024tel/DSC09394.webp";
import tel24_33_600 from "../../assets/images/gallery/600/2024tel/DSC09394.webp";
import tel24_33_1366 from "../../assets/images/gallery/1366/2024tel/DSC09394.webp";
import tel24_34_360 from "../../assets/images/gallery/360/2024tel/DSC09448.webp";
import tel24_34_600 from "../../assets/images/gallery/600/2024tel/DSC09448.webp";
import tel24_34_1366 from "../../assets/images/gallery/1366/2024tel/DSC09448.webp";
import tel24_35_360 from "../../assets/images/gallery/360/2024tel/DSC09486.webp";
import tel24_35_600 from "../../assets/images/gallery/600/2024tel/DSC09486.webp";
import tel24_35_1366 from "../../assets/images/gallery/1366/2024tel/DSC09486.webp";
import tel24_36_360 from "../../assets/images/gallery/360/2024tel/DSC09608.webp";
import tel24_36_600 from "../../assets/images/gallery/600/2024tel/DSC09608.webp";
import tel24_36_1366 from "../../assets/images/gallery/1366/2024tel/DSC09608.webp";
import tel24_37_360 from "../../assets/images/gallery/360/2024tel/DSC09575.webp";
import tel24_37_600 from "../../assets/images/gallery/600/2024tel/DSC09575.webp";
import tel24_37_1366 from "../../assets/images/gallery/1366/2024tel/DSC09575.webp";
import tel24_38_360 from "../../assets/images/gallery/360/2024tel/DSC09506.webp";
import tel24_38_600 from "../../assets/images/gallery/600/2024tel/DSC09506.webp";
import tel24_38_1366 from "../../assets/images/gallery/1366/2024tel/DSC09506.webp";
import tel24_39_360 from "../../assets/images/gallery/360/2024tel/DSC09470.webp";
import tel24_39_600 from "../../assets/images/gallery/600/2024tel/DSC09470.webp";
import tel24_39_1366 from "../../assets/images/gallery/1366/2024tel/DSC09470.webp";
import tel24_40_360 from "../../assets/images/gallery/360/2024tel/DSC09291.webp";
import tel24_40_600 from "../../assets/images/gallery/600/2024tel/DSC09291.webp";
import tel24_40_1366 from "../../assets/images/gallery/1366/2024tel/DSC09291.webp";
import tel24_41_360 from "../../assets/images/gallery/360/2024tel/DSC09234.webp";
import tel24_41_600 from "../../assets/images/gallery/600/2024tel/DSC09234.webp";
import tel24_41_1366 from "../../assets/images/gallery/1366/2024tel/DSC09234.webp";

import tel24_42_360 from "../../assets/images/gallery/360/2024tel/DA207879.webp";
import tel24_42_600 from "../../assets/images/gallery/600/2024tel/DA207879.webp";
import tel24_42_1366 from "../../assets/images/gallery/1366/2024tel/DA207879.webp";
import tel24_43_360 from "../../assets/images/gallery/360/2024tel/DA207919.webp";
import tel24_43_600 from "../../assets/images/gallery/600/2024tel/DA207919.webp";
import tel24_43_1366 from "../../assets/images/gallery/1366/2024tel/DA207919.webp";
import tel24_44_360 from "../../assets/images/gallery/360/2024tel/DA207929.webp";
import tel24_44_600 from "../../assets/images/gallery/600/2024tel/DA207929.webp";
import tel24_44_1366 from "../../assets/images/gallery/1366/2024tel/DA207929.webp";
import tel24_45_360 from "../../assets/images/gallery/360/2024tel/DA208083.webp";
import tel24_45_600 from "../../assets/images/gallery/600/2024tel/DA208083.webp";
import tel24_45_1366 from "../../assets/images/gallery/1366/2024tel/DA208083.webp";
import tel24_46_360 from "../../assets/images/gallery/360/2024tel/DA208054.webp";
import tel24_46_600 from "../../assets/images/gallery/600/2024tel/DA208054.webp";
import tel24_46_1366 from "../../assets/images/gallery/1366/2024tel/DA208054.webp";
import tel24_47_360 from "../../assets/images/gallery/360/2024tel/DA208133.webp";
import tel24_47_600 from "../../assets/images/gallery/600/2024tel/DA208133.webp";
import tel24_47_1366 from "../../assets/images/gallery/1366/2024tel/DA208133.webp";
import tel24_48_360 from "../../assets/images/gallery/360/2024tel/DA208137.webp";
import tel24_48_600 from "../../assets/images/gallery/600/2024tel/DA208137.webp";
import tel24_48_1366 from "../../assets/images/gallery/1366/2024tel/DA208137.webp";
import tel24_49_360 from "../../assets/images/gallery/360/2024tel/DA208142.webp";
import tel24_49_600 from "../../assets/images/gallery/600/2024tel/DA208142.webp";
import tel24_49_1366 from "../../assets/images/gallery/1366/2024tel/DA208142.webp";
import tel24_50_360 from "../../assets/images/gallery/360/2024tel/DA208157.webp";
import tel24_50_600 from "../../assets/images/gallery/600/2024tel/DA208157.webp";
import tel24_50_1366 from "../../assets/images/gallery/1366/2024tel/DA208157.webp";
import tel24_51_360 from "../../assets/images/gallery/360/2024tel/DA208162.webp";
import tel24_51_600 from "../../assets/images/gallery/600/2024tel/DA208162.webp";
import tel24_51_1366 from "../../assets/images/gallery/1366/2024tel/DA208162.webp";
import tel24_52_360 from "../../assets/images/gallery/360/2024tel/DA201461.webp";
import tel24_52_600 from "../../assets/images/gallery/600/2024tel/DA201461.webp";
import tel24_52_1366 from "../../assets/images/gallery/1366/2024tel/DA201461.webp";
import tel24_53_360 from "../../assets/images/gallery/360/2024tel/DA201515.webp";
import tel24_53_600 from "../../assets/images/gallery/600/2024tel/DA201515.webp";
import tel24_53_1366 from "../../assets/images/gallery/1366/2024tel/DA201515.webp";
import tel24_54_360 from "../../assets/images/gallery/360/2024tel/DA201589.webp";
import tel24_54_600 from "../../assets/images/gallery/600/2024tel/DA201589.webp";
import tel24_54_1366 from "../../assets/images/gallery/1366/2024tel/DA201589.webp";
import tel24_55_360 from "../../assets/images/gallery/360/2024tel/DA201609.webp";
import tel24_55_600 from "../../assets/images/gallery/600/2024tel/DA201609.webp";
import tel24_55_1366 from "../../assets/images/gallery/1366/2024tel/DA201609.webp";
import tel24_56_360 from "../../assets/images/gallery/360/2024tel/DA201644.webp";
import tel24_56_600 from "../../assets/images/gallery/600/2024tel/DA201644.webp";
import tel24_56_1366 from "../../assets/images/gallery/1366/2024tel/DA201644.webp";
import tel24_57_360 from "../../assets/images/gallery/360/2024tel/DA201660.webp";
import tel24_57_600 from "../../assets/images/gallery/600/2024tel/DA201660.webp";
import tel24_57_1366 from "../../assets/images/gallery/1366/2024tel/DA201660.webp";
import tel24_58_360 from "../../assets/images/gallery/360/2024tel/DA201883.webp";
import tel24_58_600 from "../../assets/images/gallery/600/2024tel/DA201883.webp";
import tel24_58_1366 from "../../assets/images/gallery/1366/2024tel/DA201883.webp";
import tel24_59_360 from "../../assets/images/gallery/360/2024tel/DA201609.webp";
import tel24_59_600 from "../../assets/images/gallery/600/2024tel/DA201609.webp";
import tel24_59_1366 from "../../assets/images/gallery/1366/2024tel/DA201609.webp";
import tel24_60_360 from "../../assets/images/gallery/360/2024tel/DA201425_2.webp";
import tel24_60_600 from "../../assets/images/gallery/600/2024tel/DA201425_2.webp";
import tel24_60_1366 from "../../assets/images/gallery/1366/2024tel/DA201425_2.webp";
import tel24_61_360 from "../../assets/images/gallery/360/2024tel/DA201433.webp";
import tel24_61_600 from "../../assets/images/gallery/600/2024tel/DA201433.webp";
import tel24_61_1366 from "../../assets/images/gallery/1366/2024tel/DA201433.webp";
import tel24_62_360 from "../../assets/images/gallery/360/2024tel/DSC00911.webp";
import tel24_62_600 from "../../assets/images/gallery/600/2024tel/DSC00911.webp";
import tel24_62_1366 from "../../assets/images/gallery/1366/2024tel/DSC00911.webp";
import tel24_63_360 from "../../assets/images/gallery/360/2024tel/DSC00966.webp";
import tel24_63_600 from "../../assets/images/gallery/600/2024tel/DSC00966.webp";
import tel24_63_1366 from "../../assets/images/gallery/1366/2024tel/DSC00966.webp";
import tel24_64_360 from "../../assets/images/gallery/360/2024tel/DSC01018.webp";
import tel24_64_600 from "../../assets/images/gallery/600/2024tel/DSC01018.webp";
import tel24_64_1366 from "../../assets/images/gallery/1366/2024tel/DSC01018.webp";
import tel24_65_360 from "../../assets/images/gallery/360/2024tel/DSC00865.webp";
import tel24_65_600 from "../../assets/images/gallery/600/2024tel/DSC00865.webp";
import tel24_65_1366 from "../../assets/images/gallery/1366/2024tel/DSC00865.webp";
import tel24_66_360 from "../../assets/images/gallery/360/2024tel/DSC00897.webp";
import tel24_66_600 from "../../assets/images/gallery/600/2024tel/DSC00897.webp";
import tel24_66_1366 from "../../assets/images/gallery/1366/2024tel/DSC00897.webp";

import tel24_67_360 from "../../assets/images/gallery/360/2024tel/DSC02832.webp";
import tel24_67_600 from "../../assets/images/gallery/600/2024tel/DSC02832.webp";
import tel24_67_1366 from "../../assets/images/gallery/1366/2024tel/DSC02832.webp";
import tel24_68_360 from "../../assets/images/gallery/360/2024tel/DSC02845.webp";
import tel24_68_600 from "../../assets/images/gallery/600/2024tel/DSC02845.webp";
import tel24_68_1366 from "../../assets/images/gallery/1366/2024tel/DSC02845.webp";
import tel24_69_360 from "../../assets/images/gallery/360/2024tel/DSC02862.webp";
import tel24_69_600 from "../../assets/images/gallery/600/2024tel/DSC02862.webp";
import tel24_69_1366 from "../../assets/images/gallery/1366/2024tel/DSC02862.webp";
import tel24_70_360 from "../../assets/images/gallery/360/2024tel/DSC02896.webp";
import tel24_70_600 from "../../assets/images/gallery/600/2024tel/DSC02896.webp";
import tel24_70_1366 from "../../assets/images/gallery/1366/2024tel/DSC02896.webp";
import tel24_71_360 from "../../assets/images/gallery/360/2024tel/DSC02942.webp";
import tel24_71_600 from "../../assets/images/gallery/600/2024tel/DSC02942.webp";
import tel24_71_1366 from "../../assets/images/gallery/1366/2024tel/DSC02942.webp";
import tel24_72_360 from "../../assets/images/gallery/360/2024tel/DSC02952.webp";
import tel24_72_600 from "../../assets/images/gallery/600/2024tel/DSC02952.webp";
import tel24_72_1366 from "../../assets/images/gallery/1366/2024tel/DSC02952.webp";
import tel24_73_360 from "../../assets/images/gallery/360/2024tel/DSC03053.webp";
import tel24_73_600 from "../../assets/images/gallery/600/2024tel/DSC03053.webp";
import tel24_73_1366 from "../../assets/images/gallery/1366/2024tel/DSC03053.webp";

import tel24_74_360 from "../../assets/images/gallery/360/2024tel/DSC03934.webp";
import tel24_74_600 from "../../assets/images/gallery/600/2024tel/DSC03934.webp";
import tel24_74_1366 from "../../assets/images/gallery/1366/2024tel/DSC03934.webp";
import tel24_75_360 from "../../assets/images/gallery/360/2024tel/DSC04055.webp";
import tel24_75_600 from "../../assets/images/gallery/600/2024tel/DSC04055.webp";
import tel24_75_1366 from "../../assets/images/gallery/1366/2024tel/DSC04055.webp";
import tel24_76_360 from "../../assets/images/gallery/360/2024tel/DSC04124.webp";
import tel24_76_600 from "../../assets/images/gallery/600/2024tel/DSC04124.webp";
import tel24_76_1366 from "../../assets/images/gallery/1366/2024tel/DSC04124.webp";
import tel24_77_360 from "../../assets/images/gallery/360/2024tel/DSC04141.webp";
import tel24_77_600 from "../../assets/images/gallery/600/2024tel/DSC04141.webp";
import tel24_77_1366 from "../../assets/images/gallery/1366/2024tel/DSC04141.webp";
import tel24_78_360 from "../../assets/images/gallery/360/2024tel/DSC04201-Enhanced-NR.webp";
import tel24_78_600 from "../../assets/images/gallery/600/2024tel/DSC04201-Enhanced-NR.webp";
import tel24_78_1366 from "../../assets/images/gallery/1366/2024tel/DSC04201-Enhanced-NR.webp";
import tel24_79_360 from "../../assets/images/gallery/360/2024tel/DSC04206.webp";
import tel24_79_600 from "../../assets/images/gallery/600/2024tel/DSC04206.webp";
import tel24_79_1366 from "../../assets/images/gallery/1366/2024tel/DSC04206.webp";
import tel24_80_360 from "../../assets/images/gallery/360/2024tel/DSC04208-Enhanced-NR.webp";
import tel24_80_600 from "../../assets/images/gallery/600/2024tel/DSC04208-Enhanced-NR.webp";
import tel24_80_1366 from "../../assets/images/gallery/1366/2024tel/DSC04208-Enhanced-NR.webp";

import jan25_1_360 from "../../assets/images/gallery/360/2025jan/1.webp";
import jan25_1_600 from "../../assets/images/gallery/600/2025jan/1.webp";
import jan25_1_1366 from "../../assets/images/gallery/1366/2025jan/1.webp";
import jan25_2_360 from "../../assets/images/gallery/360/2025jan/2.webp";
import jan25_2_600 from "../../assets/images/gallery/600/2025jan/2.webp";
import jan25_2_1366 from "../../assets/images/gallery/1366/2025jan/2.webp";
import jan25_3_360 from "../../assets/images/gallery/360/2025jan/3.webp";
import jan25_3_600 from "../../assets/images/gallery/600/2025jan/3.webp";
import jan25_3_1366 from "../../assets/images/gallery/1366/2025jan/3.webp";
import jan25_4_360 from "../../assets/images/gallery/360/2025jan/4.webp";
import jan25_4_600 from "../../assets/images/gallery/600/2025jan/4.webp";
import jan25_4_1366 from "../../assets/images/gallery/1366/2025jan/4.webp";
import jan25_5_360 from "../../assets/images/gallery/360/2025jan/5.webp";
import jan25_5_600 from "../../assets/images/gallery/600/2025jan/5.webp";
import jan25_5_1366 from "../../assets/images/gallery/1366/2025jan/5.webp";
import jan25_6_360 from "../../assets/images/gallery/360/2025jan/6.webp";
import jan25_6_600 from "../../assets/images/gallery/600/2025jan/6.webp";
import jan25_6_1366 from "../../assets/images/gallery/1366/2025jan/6.webp";
import jan25_7_360 from "../../assets/images/gallery/360/2025jan/DSC08394.webp";
import jan25_7_600 from "../../assets/images/gallery/600/2025jan/DSC08394.webp";
import jan25_7_1366 from "../../assets/images/gallery/1366/2025jan/DSC08394.webp";
import jan25_8_360 from "../../assets/images/gallery/360/2025jan/DSC08462.webp";
import jan25_8_600 from "../../assets/images/gallery/600/2025jan/DSC08462.webp";
import jan25_8_1366 from "../../assets/images/gallery/1366/2025jan/DSC08462.webp";
import jan25_9_360 from "../../assets/images/gallery/360/2025jan/DSC08500.webp";
import jan25_9_600 from "../../assets/images/gallery/600/2025jan/DSC08500.webp";
import jan25_9_1366 from "../../assets/images/gallery/1366/2025jan/DSC08500.webp";
import jan25_10_360 from "../../assets/images/gallery/360/2025jan/DSC08512.webp";
import jan25_10_600 from "../../assets/images/gallery/600/2025jan/DSC08512.webp";
import jan25_10_1366 from "../../assets/images/gallery/1366/2025jan/DSC08512.webp";

import jan25_11_360 from "../../assets/images/gallery/360/2025jan/DSC09578.webp";
import jan25_11_600 from "../../assets/images/gallery/600/2025jan/DSC09578.webp";
import jan25_11_1366 from "../../assets/images/gallery/1366/2025jan/DSC09578.webp";
import jan25_12_360 from "../../assets/images/gallery/360/2025jan/DSC09507.webp";
import jan25_12_600 from "../../assets/images/gallery/600/2025jan/DSC09507.webp";
import jan25_12_1366 from "../../assets/images/gallery/1366/2025jan/DSC09507.webp";
import jan25_13_360 from "../../assets/images/gallery/360/2025jan/DSC09509.webp";
import jan25_13_600 from "../../assets/images/gallery/600/2025jan/DSC09509.webp";
import jan25_13_1366 from "../../assets/images/gallery/1366/2025jan/DSC09509.webp";
import jan25_14_360 from "../../assets/images/gallery/360/2025jan/DSC09543.webp";
import jan25_14_600 from "../../assets/images/gallery/600/2025jan/DSC09543.webp";
import jan25_14_1366 from "../../assets/images/gallery/1366/2025jan/DSC09543.webp";
import jan25_15_360 from "../../assets/images/gallery/360/2025jan/DSC09552.webp";
import jan25_15_600 from "../../assets/images/gallery/600/2025jan/DSC09552.webp";
import jan25_15_1366 from "../../assets/images/gallery/1366/2025jan/DSC09552.webp";
import jan25_16_360 from "../../assets/images/gallery/360/2025jan/DSC09572.webp";
import jan25_16_600 from "../../assets/images/gallery/600/2025jan/DSC09572.webp";
import jan25_16_1366 from "../../assets/images/gallery/1366/2025jan/DSC09572.webp";
import jan25_17_360 from "../../assets/images/gallery/360/2025jan/DSC09581.webp";
import jan25_17_600 from "../../assets/images/gallery/600/2025jan/DSC09581.webp";
import jan25_17_1366 from "../../assets/images/gallery/1366/2025jan/DSC09581.webp";
import jan25_18_360 from "../../assets/images/gallery/360/2025jan/DSC09640.webp";
import jan25_18_600 from "../../assets/images/gallery/600/2025jan/DSC09640.webp";
import jan25_18_1366 from "../../assets/images/gallery/1366/2025jan/DSC09640.webp";
import jan25_19_360 from "../../assets/images/gallery/360/2025jan/DSC09673.webp";
import jan25_19_600 from "../../assets/images/gallery/600/2025jan/DSC09673.webp";
import jan25_19_1366 from "../../assets/images/gallery/1366/2025jan/DSC09673.webp";
import jan25_20_360 from "../../assets/images/gallery/360/2025jan/DSC09685.webp";
import jan25_20_600 from "../../assets/images/gallery/600/2025jan/DSC09685.webp";
import jan25_20_1366 from "../../assets/images/gallery/1366/2025jan/DSC09685.webp";
import jan25_21_360 from "../../assets/images/gallery/360/2025jan/DSC09706.webp";
import jan25_21_600 from "../../assets/images/gallery/600/2025jan/DSC09706.webp";
import jan25_21_1366 from "../../assets/images/gallery/1366/2025jan/DSC09706.webp";

import jan25_22_360 from "../../assets/images/gallery/360/2025jan/DSC09727.webp";
import jan25_22_600 from "../../assets/images/gallery/600/2025jan/DSC09727.webp";
import jan25_22_1366 from "../../assets/images/gallery/1366/2025jan/DSC09727.webp";
import jan25_23_360 from "../../assets/images/gallery/360/2025jan/DSC09740.webp";
import jan25_23_600 from "../../assets/images/gallery/600/2025jan/DSC09740.webp";
import jan25_23_1366 from "../../assets/images/gallery/1366/2025jan/DSC09740.webp";

import jan25_24_360 from "../../assets/images/gallery/360/2025jan/7.webp";
import jan25_24_600 from "../../assets/images/gallery/600/2025jan/7.webp";
import jan25_24_1366 from "../../assets/images/gallery/1366/2025jan/7.webp";
import jan25_25_360 from "../../assets/images/gallery/360/2025jan/8.webp";
import jan25_25_600 from "../../assets/images/gallery/600/2025jan/8.webp";
import jan25_25_1366 from "../../assets/images/gallery/1366/2025jan/8.webp";
import jan25_26_360 from "../../assets/images/gallery/360/2025jan/9.webp";
import jan25_26_600 from "../../assets/images/gallery/600/2025jan/9.webp";
import jan25_26_1366 from "../../assets/images/gallery/1366/2025jan/9.webp";
import jan25_27_360 from "../../assets/images/gallery/360/2025jan/10.webp";
import jan25_27_600 from "../../assets/images/gallery/600/2025jan/10.webp";
import jan25_27_1366 from "../../assets/images/gallery/1366/2025jan/10.webp";
import jan25_28_360 from "../../assets/images/gallery/360/2025jan/jan27--4.webp";
import jan25_28_600 from "../../assets/images/gallery/600/2025jan/jan27--4.webp";
import jan25_28_1366 from "../../assets/images/gallery/1366/2025jan/jan27--4.webp";
import jan25_29_360 from "../../assets/images/gallery/360/2025jan/jan27--6.webp";
import jan25_29_600 from "../../assets/images/gallery/600/2025jan/jan27--6.webp";
import jan25_29_1366 from "../../assets/images/gallery/1366/2025jan/jan27--6.webp";
import jan25_30_360 from "../../assets/images/gallery/360/2025jan/jan27-02274.webp";
import jan25_30_600 from "../../assets/images/gallery/600/2025jan/jan27-02274.webp";
import jan25_30_1366 from "../../assets/images/gallery/1366/2025jan/jan27-02274.webp";
import jan25_31_360 from "../../assets/images/gallery/360/2025jan/jan27-02279.webp";
import jan25_31_600 from "../../assets/images/gallery/600/2025jan/jan27-02279.webp";
import jan25_31_1366 from "../../assets/images/gallery/1366/2025jan/jan27-02279.webp";

import random1_360 from "../../assets/images/gallery/360/2023nov/27.webp";
import random1_600 from "../../assets/images/gallery/600/2023nov/27.webp";
import random1_1366 from "../../assets/images/gallery/1366/2023nov/27.webp";
import random2_360 from "../../assets/images/gallery/360/kisfaludy/DunaCruises-BP-1568_mod_water&sky.webp";
import random2_600 from "../../assets/images/gallery/600/kisfaludy/DunaCruises-BP-1568_mod_water&sky.webp";
import random2_1366 from "../../assets/images/gallery/1366/kisfaludy/DunaCruises-BP-1568_mod_water&sky.webp";
//IMGS END
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, Thumbs, FreeMode } from "swiper";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/thumbs";

import { useInView } from "react-intersection-observer";

export let drinks = [
  { alt: "main1.gallery.alts.bar1", small: tavasz5_360, med: tavasz5_600, big: tavasz5_1366 },
  { alt: "main1.gallery.alts.bar1", small: bar1_360, med: bar1_600, big: bar1_1366 },
  { alt: "main1.gallery.alts.bar1", small: tavasz14_360, med: tavasz14_600, big: tavasz14_1366 },

  { alt: "main1.gallery.alts.bar1", small: gallery44_360, med: gallery44_600, big: gallery44_1024 },

  { alt: "main1.gallery.alts.bar1", small: tavasz8_360, med: tavasz8_600, big: tavasz8_1366 },
  { alt: "main1.gallery.alts.bar2", small: bar2_360, med: bar2_600, big: bar2_1366 },

  { alt: "main1.gallery.alts.bar1", small: tavasz12_360, med: tavasz12_600, big: tavasz12_1366 },
  { alt: "main1.gallery.alts.bar7", small: bar7_360, med: bar7_600, big: bar7_1366 },
  { alt: "main1.gallery.alts.bar8", small: bar8_360, med: bar8_600, big: bar8_1366 },
  { alt: "main1.gallery.alts.bar8", small: bar9_360, med: bar9_600, big: bar9_1366 },

  { alt: "main1.gallery.alts.bar8", small: bar17_360, med: bar17_600, big: bar17_1366 },
  { alt: "main1.gallery.alts.bar8", small: bar18_360, med: bar18_600, big: bar18_1366 },
  { alt: "main1.gallery.alts.bar5", small: bar5_360, med: bar5_600, big: bar5_1366 },
];

let ujgal3_360 = kf5_360;
let ujgal3_600 = kf5_600;
let ujgal3_1366 = kf5_1366;

let ujgal5_360 = gal17_360;
let ujgal5_600 = gal17_600;
let ujgal5_1366 = gal17_1366;
let ujgal6_360 = gal38_360;
let ujgal6_600 = gal38_600;
let ujgal6_1366 = gal38_1366;
let ujgal7_360 = feb15_360;
let ujgal7_600 = feb15_600;
let ujgal7_1366 = feb15_1366;
let ujgal8_360 = night2_360;
let ujgal8_600 = night2_600;
let ujgal8_1366 = night2_1366;
let ujgal11_360 = kftavasz6_360;
let ujgal11_600 = kftavasz6_600;
let ujgal11_1366 = kftavasz6_1366;

export let bestOf = [
  {
    alt: "main1.gallery.alts.historical.4",
    pos: "50% 10%",
    small: kf3_360,
    ship: "kisfaludy",
    med: kf3_600,
    cat: ["daytime", "historical", "outdoor", "drinks"],
    big: kf3_1366,
  },

  {
    alt: "main1.gallery.alts.historical.2",
    small: kf13_360,
    ship: "kisfaludy",
    cat: ["nighttime", "historical", "outdoor"],
    med: kf13_600,
    big: kf13_1366,
    pos: "80% 80%",
  },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: ujgal6_360,
    med: ujgal6_600,
    big: ujgal6_1366,
    cat: ["daytime", "elegant", "indoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: nyar4_360,
    med: nyar4_600,
    big: nyar4_1366,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: tavasz4_360,
    med: tavasz4_600,
    big: tavasz4_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: ujgal11_360,
    med: ujgal11_600,
    big: ujgal11_1366,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    alt: "main1.gallery.alts.historical.2",
    small: kf2_360,
    ship: "kisfaludy",
    cat: ["daytime", "historical", "indoor"],
    med: kf2_600,
    big: kf2_1366,
  },
  {
    ship: "hableany",

    small: nyar_24_7_360,
    alt: "main1.gallery.alts.historical.1",
    med: nyar_24_7_600,
    big: nyar_24_7_1366,
    cat: ["daytime", "historical", "outdoor", "drinks"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: ujgal3_360,
    pos: "50% 70%",
    med: ujgal3_600,
    cat: ["daytime", "historical", "outdoor"],
    big: ujgal3_1366,
  },
  {
    alt: "main1.gallery.alts.elegant.2",
    small: nyar2_360,
    med: nyar2_600,
    big: nyar2_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
    ship: "citadella",
  },

  {
    alt: "main1.gallery.alts.historical.3",
    small: kf1_360,
    med: kf1_600,
    ship: "kisfaludy",
    big: kf1_1366,
    cat: ["daytime", "historical", "outdoor"],
    pos: "50% 70%",
  },
  {
    alt: "main1.gallery.alts.historical.4",
    small: hab7_360,
    cat: ["daytime", "historical", "outdoor"],
    med: hab7_600,
    ship: "hableany",
    big: hab7_1366,
  },

  {
    alt: "main1.gallery.alts.elegant.2",
    small: nyar3_360,
    med: nyar3_600,
    big: nyar3_1366,
    ship: "citadella",
    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: feb10_360,
    med: feb10_600,
    pos: "50% 100%",
    big: feb10_1366,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: nyar_24_9_360,
    med: nyar_24_9_600,
    big: nyar_24_9_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.4",
    small: nyar_24_15_360,
    med: nyar_24_15_600,
    big: nyar_24_15_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: nyar_24_8_360,
    med: nyar_24_8_600,
    big: nyar_24_8_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    alt: "main1.gallery.alts.elegant.1",
    small: kf19_360,
    med: kf19_600,
    big: kf19_1366,
    ship: "citadella",
    pos: "50% 80%",
    cat: ["daytime", "elegant", "outdoor"],
  },

  {
    alt: "main1.gallery.altselegant.2",
    small: tavasz37_360,
    med: tavasz37_600,
    big: tavasz37_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
    ship: "citadella",
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: nyar_24_6_360,
    med: nyar_24_6_600,
    cat: ["daytime", "elegant", "outdoor"],
    big: nyar_24_6_1366,
    pos: "50% 40%",
  },
  {
    alt: "main1.gallery.alts.historical.3",
    small: kf17_360,
    med: kf17_600,
    ship: "kisfaludy",
    cat: ["daytime", "historical", "outdoor"],
    big: kf17_1366,
    pos: "50% 70%",
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.4",
    small: nyar_24_1_360,
    med: nyar_24_1_600,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
    big: nyar_24_1_1366,
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.4",
    small: nyar_24_10_360,
    med: nyar_24_10_600,
    cat: ["daytime", "historical", "outdoor", "drinks"],
    big: nyar_24_10_1366,
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: kftavasz1_360,
    ship: "kisfaludy",
    med: kftavasz1_600,
    cat: ["daytime", "historical", "outdoor"],
    big: kftavasz1_1366,
  },

  {
    alt: "main1.gallery.alts.historical.2",
    ship: "kisfaludy",
    small: kf11_360,
    med: kf11_600,
    big: kf11_1366,
    cat: ["daytime", "historical", "outdoor"],
    pos: "50% 80%",
  },
  {
    alt: "main1.gallery.alts.historical.3",
    small: hab5_360,
    ship: "hableany",
    cat: ["daytime", "historical", "outdoor", "drinks"],
    med: hab5_600,
    big: hab5_1366,
  },
  {
    ship: "citadella",

    alt: "main1.gallery.alts.elegant.1",
    cat: ["daytime", "elegant", "indoor", "drinks"],
    small: nyar_24_2_360,
    med: nyar_24_2_600,
    big: nyar_24_2_1366,
  },
  {
    alt: "main1.gallery.alts.historical.4",
    ship: "hableany",
    small: hab6_360,
    cat: ["daytime", "historical", "outdoor"],
    med: hab6_600,
    big: hab6_1366,
  },
];
export let jan25 = [
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: jan25_1_360,
    med: jan25_1_600,
    big: jan25_1_1366,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: jan25_2_360,
    med: jan25_2_600,
    big: jan25_2_1366,
    cat: ["nighttime", "elegant", "indoor", "drink"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: jan25_2_360,
    med: jan25_2_600,
    big: jan25_2_1366,
    cat: ["nighttime", "elegant", "indoor", "drink"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: jan25_4_360,
    med: jan25_4_600,
    big: jan25_4_1366,
    cat: ["nighttime", "elegant", "outdoor", "drink"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: jan25_5_360,
    med: jan25_5_600,
    big: jan25_5_1366,
    cat: ["nighttime", "elegant", "outdoor", "drink"],
  },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: jan25_6_360,
    med: jan25_6_600,
    big: jan25_6_1366,
    cat: ["nighttime", "elegant", "outdoor", "drink"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
    small: jan25_7_360,
    med: jan25_7_600,
    big: jan25_7_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "kisfaludy",

    alt: "main1.gallery.alts.historical.2",
    small: jan25_8_360,
    med: jan25_8_600,
    big: jan25_8_1366,
    pos: "50% 90%",
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: jan25_9_360,
    med: jan25_9_600,
    big: jan25_9_1366,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: jan25_10_360,
    med: jan25_10_600,
    big: jan25_10_1366,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: jan25_11_360,
    med: jan25_11_600,
    big: jan25_11_1366,
    cat: ["daytime", "historical", "indoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: jan25_12_360,
    med: jan25_12_600,
    big: jan25_12_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.3",
    small: jan25_13_360,
    med: jan25_13_600,
    big: jan25_13_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: jan25_14_360,
    med: jan25_14_600,
    big: jan25_14_1366,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: jan25_15_360,
    med: jan25_15_600,
    big: jan25_15_1366,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
    small: jan25_16_360,
    med: jan25_16_600,
    big: jan25_16_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: jan25_17_360,
    med: jan25_17_600,
    big: jan25_17_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.3",
    small: jan25_18_360,
    med: jan25_18_600,
    big: jan25_18_1366,
    cat: ["daytime", "historical", "indoor", "drink"],
  },
  // {
  //   ship: "kisfaludy",
  //   alt: "main1.gallery.alts.historical.1",
  //   small: jan25_19_360,
  //   med: jan25_19_600,
  //   big: jan25_19_1366,
  //   cat: ["daytime", "historical", "outdoor"],
  // },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: jan25_20_360,
    med: jan25_20_600,
    big: jan25_20_1366,
    cat: ["daytime", "historical", "outdoor", "drink"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
    small: jan25_21_360,
    med: jan25_21_600,
    big: jan25_21_1366,
    cat: ["daytime", "historical", "indoor", "drink"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: jan25_21_360,
    med: jan25_21_600,
    big: jan25_21_1366,
    cat: ["daytime", "historical", "indoor", "drink"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.3",
    small: jan25_22_360,
    med: jan25_22_600,
    big: jan25_22_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
    small: jan25_23_360,
    med: jan25_23_600,
    big: jan25_23_1366,
    cat: ["daytime", "historical", "indoor", "drink"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: jan25_24_360,
    med: jan25_24_600,
    big: jan25_24_1366,
    cat: ["nighttime", "elegant", "indoor", "drink"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: jan25_25_360,
    med: jan25_25_600,
    big: jan25_25_1366,
    cat: ["nighttime", "elegant", "outdoor", "drink"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: jan25_26_360,
    med: jan25_26_600,
    big: jan25_26_1366,
    cat: ["nighttime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: jan25_27_360,
    med: jan25_27_600,
    big: jan25_27_1366,
    cat: ["nighttime", "elegant", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
    small: jan25_28_360,
    med: jan25_28_600,
    big: jan25_28_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: jan25_29_360,
    med: jan25_29_600,
    big: jan25_29_1366,
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.3",
    small: jan25_30_360,
    med: jan25_30_600,
    big: jan25_30_1366,
    cat: ["nighttime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: jan25_31_360,
    med: jan25_31_600,
    big: jan25_31_1366,
    cat: ["nighttime", "elegant", "outdoor"],
  },
];
export let nighttime = [
  { alt: "main1.gallery.alts.bar8", small: night1_360, med: night1_600, big: night1_1366 },
  { alt: "main1.gallery.alts.bar8", small: night2_360, med: night2_600, big: night2_1366 },
  { alt: "main1.gallery.alts.bar8", small: night3_360, med: night3_600, big: night3_1366 },

  { alt: "main1.gallery.alts.bar8", small: evening7_360, med: evening7_600, big: evening7_1366 },
  { alt: "main1.gallery.alts.bar8", small: night6_360, med: night6_600, big: night6_1366 },

  { alt: "main1.gallery.alts.bar8", small: evening2_360, med: evening2_600, big: evening2_1366 },
];
export let historical = [
  {
    alt: "main1.gallery.alts.bar8",
    small: kf13_360,
    med: kf13_600,
    big: kf13_1366,
    ship: "kisfaludy",
    pos: "80% 80%",
  },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.2",
  //   small: tel24_41_360,
  //   med: tel24_41_600,
  //   big: tel24_41_1366,

  //   cat: ["daytime", "historical", "outdoor", "drinks"],
  // },

  // {
  //   alt: "main1.gallery.alts.bar8",
  //   small: hab4_360,
  //   med: hab4_600,
  //   ship: "hableany",
  //   big: hab4_1366,
  // },
  // {
  //   alt: "main1.gallery.alts.bar8",
  //   ship: "hableany",
  //   small: hab1_360,
  //   med: hab1_600,
  //   big: hab1_1366,
  // },
  // { alt: "main1.gallery.alts.bar8", small: kf5_360, med: kf5_600, big: kf5_1366 },
  // { alt: "main1.gallery.alts.bar8", small: kf9_360, med: kf9_600, big: kf9_1366 },

  // {
  //   alt: "main1.gallery.alts.bar8",
  //   small: kftavasz1_360,
  //   med: kftavasz1_600,
  //   big: kftavasz1_1366,
  //   ship: "kisfaludy",
  // },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.1",
  //   small: tel24_72_360,
  //   med: tel24_72_600,
  //   id: 72,
  //   big: tel24_72_1366,

  //   cat: ["daytime", "historical", "outdoor"],
  // },

  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.2",
  //   small: jan25_19_360,
  //   med: jan25_19_600,
  //   big: jan25_19_1366,

  //   cat: ["daytime", "historical", "outdoor", "drinks"],
  // },

  {
    alt: "main1.gallery.alts.historical.3",
    small: kf32_360,
    med: kf32_600,
    big: kf32_1366,
    ship: "kisfaludy",
  },

  {
    alt: "main1.gallery.alts.bar8",
    small: hab7_360,
    ship: "hableany",
    med: hab7_600,
    big: hab7_1366,
  },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.2",
  //   small: tel24_44_360,
  //   med: tel24_44_600,
  //   big: tel24_44_1366,

  //   cat: ["daytime", "historical", "outdoor", "drinks"],
  // },
  // {
  //   alt: "main1.gallery.alts.bar8",
  //   ship: "kisfaludy",
  //   small: kf3_360,
  //   med: kf3_600,
  //   big: kf3_1366,
  //   pos: "50% 15%",
  // },

  {
    alt: "main1.gallery.alts.bar8",
    small: kf12_360,
    med: kf12_600,
    big: kf12_1366,
    pos: "50% 80%",
    ship: "kisfaludy",
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: osz24_12_360,
    med: osz24_12_600,
    big: osz24_12_1366,

    cat: ["daytime", "historical", "outdoor"],
  },

  {
    alt: "main1.gallery.alts.bar8",
    small: kf6_360,
    med: kf6_600,
    big: kf6_1366,
    pos: "50% 80%",
    ship: "kisfaludy",
  },
  {
    alt: "main1.gallery.alts.bar8",
    small: hab3_360,
    med: hab3_600,
    big: hab3_1366,
    ship: "hableany",
  },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.2",
  //   small: tel24_52_360,
  //   med: tel24_52_600,
  //   big: tel24_52_1366,

  //   cat: ["daytime", "historical", "outdoor", "drinks"],
  // },
  {
    alt: "main1.gallery.alts.bar8",
    small: kf14_360,
    med: kf14_600,
    big: kf14_1366,
    ship: "kisfaludy",
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: tel24_33_360,
    med: tel24_33_600,
    big: tel24_33_1366,

    cat: ["daytime", "historical", "outdoor", "drinks"],
  },
  {
    alt: "main1.gallery.alts.bar1",
    small: nyar_24_9_360,
    med: nyar_24_9_600,
    big: nyar_24_9_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.bar8",
    small: hab2_360,
    ship: "hableany",
    med: hab2_600,
    big: hab2_1366,
  },
  {
    alt: "main1.gallery.alts.bar8",
    small: hab5_360,
    med: hab5_600,
    ship: "hableany",
    big: hab5_1366,
  },
  {
    alt: "main1.gallery.alts.historical.2",
    small: hab8_360,
    ship: "kisfaludy",
    med: hab8_600,
    big: hab8_1366,
  },

  {
    alt: "main1.gallery.alts.historical.3",
    small: kf30_360,
    med: kf30_600,
    big: kf30_1366,
    ship: "kisfaludy",
  },
  {
    alt: "main1.gallery.alts.historical.3",
    small: kf31_360,
    med: kf31_600,
    big: kf31_1366,
    ship: "kisfaludy",
  },

  {
    alt: "main1.gallery.alts.historical.3",
    small: kf33_360,
    med: kf33_600,
    big: kf33_1366,
    ship: "kisfaludy",
  },
];
export let hab = [
  // {
  //   alt: "main1.gallery.alts.historical.1",
  //   small: hab10_360,
  //   med: hab10_600,
  //   big: hab10_1366,
  //   ship: "hableany",
  // },

  {
    alt: "main1.gallery.alts.historical.1",
    small: hab12_360,
    med: hab12_600,
    big: hab12_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab13_360,
    med: hab13_600,
    big: hab13_1366,
    ship: "hableany",
  },

  {
    alt: "main1.gallery.alts.historical.1",
    small: hab15_360,
    med: hab15_600,
    big: hab15_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab32_360,
    med: hab32_600,
    big: hab32_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab20_360,
    med: hab20_600,
    big: hab20_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab16_360,
    med: hab16_600,
    big: hab16_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab17_360,
    med: hab17_600,
    big: hab17_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab18_360,
    med: hab18_600,
    big: hab18_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab33_360,
    med: hab33_600,
    big: hab33_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab19_360,
    med: hab19_600,
    big: hab19_1366,
    ship: "hableany",
  },

  {
    alt: "main1.gallery.alts.historical.1",
    small: hab31_360,
    med: hab31_600,
    big: hab31_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab21_360,
    med: hab21_600,
    big: hab21_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab11_360,
    med: hab11_600,
    big: hab11_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab22_360,
    med: hab22_600,
    big: hab22_1366,
    ship: "hableany",
  },

  // {
  //   alt: "main1.gallery.alts.historical.1",
  //   small: hab23_360,
  //   med: hab23_600,
  //   big: hab23_1366,
  //   ship: "hableany",
  // },
  // {
  //   alt: "main1.gallery.alts.historical.1",
  //   small: hab24_360,
  //   med: hab24_600,
  //   big: hab24_1366,
  //   ship: "hableany",
  // },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab25_360,
    med: hab25_600,
    big: hab25_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab26_360,
    med: hab26_600,
    big: hab26_1366,
    ship: "hableany",
  },
  // {
  //   alt: "main1.gallery.alts.historical.1",
  //   small: hab27_360,
  //   med: hab27_600,
  //   big: hab27_1366,
  //   ship: "hableany",
  // },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab28_360,
    med: hab28_600,
    big: hab28_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab29_360,
    med: hab29_600,
    big: hab29_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab14_360,
    med: hab14_600,
    big: hab14_1366,
    ship: "hableany",
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: hab30_360,
    med: hab30_600,
    big: hab30_1366,
    ship: "hableany",
  },
];

export let elegant = [
  // {
  //   alt: "main1.gallery.alts.fallback",
  //   small: kf15_360,
  //   med: kf15_600,
  //   big: kf15_1366,
  //   pos: "50% 60%",
  // },

  {
    alt: "main1.gallery.alts.fallback",
    small: kftavasz6_360,
    med: kftavasz6_600,
    big: kftavasz6_1366,
    pos: "50% 80%",
  },
  {
    alt: "main1.gallery.alts.fallback",
    small: random1_360,
    med: random1_600,
    big: random1_1366,
    pos: "50% 15%",
  },
  // {
  //   alt: "main1.gallery.alts.fallback",
  //   small: tavasz29_360,
  //   med: tavasz29_600,
  //   big: tavasz29_1366,
  // },
  {
    alt: "main1.gallery.alts.fallback",
    small: night1_360,
    med: night1_600,
    big: night1_1366,
    pos: "50% 100%",
  },

  // { alt: "main1.gallery.alts.fallback", small: day7_360, med: day7_600, big: day7_1366 },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_07_360,
    med: tel24_07_600,
    big: tel24_07_1366,

    cat: ["daytime", "elegant", "indoor"],
  },
  {
    alt: "main1.gallery.alts.fallback",
    small: evening3_360,
    med: evening3_600,
    big: evening3_1366,
  },
  { alt: "main1.gallery.alts.fallback", small: night3_360, med: night3_600, big: night3_1366 },
  {
    alt: "main1.gallery.alts.fallback",
    small: tavasz37_360,
    med: tavasz37_600,
    big: tavasz37_1366,
  },
];
export let daytime = [
  // { alt: "main1.gallery.alts.fallback", small: day1_360, med: day1_1366, big: day1_1366 },
  elegant[0],
  { alt: "main1.gallery.alts.fallback", small: day9_360, med: day9_600, big: day9_1366 },
  { alt: "main1.gallery.alts.fallback", small: day4_360, med: day4_600, big: day4_1366 },
  { alt: "main1.gallery.alts.fallback", small: day2_360, med: day2_600, big: day2_1366 },
  { alt: "main1.gallery.alts.fallback", small: day7_360, med: day7_600, big: day7_1366 },
  { alt: "main1.gallery.alts.fallback", small: day6_360, med: day6_600, big: day6_1366 },
  { alt: "main1.gallery.alts.fallback", small: day5_360, med: day5_600, big: day5_1366 },

  { alt: "main1.gallery.alts.fallback", small: day10_360, med: day10_600, big: day10_1366 },
];
export let osz24 = [
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: osz24_2_360,
    med: osz24_2_600,
    big: osz24_2_1366,

    cat: ["nighttime", "historical", "outdoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.3",
    small: osz24_3_360,
    med: osz24_3_600,
    big: osz24_3_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: osz24_1_360,
    med: osz24_1_600,
    big: osz24_1_1366,

    cat: ["daytime", "historical", "outdoor"],
  },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: osz24_5_360,
    med: osz24_5_600,
    big: osz24_5_1366,

    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: osz24_6_360,
    med: osz24_6_600,
    big: osz24_6_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: osz24_17_360,
    med: osz24_17_600,
    big: osz24_17_1366,

    cat: ["daytime", "elegant", "drinks", "outdoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: osz24_7_360,
    med: osz24_7_600,
    big: osz24_7_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: osz24_9_360,
    med: osz24_9_600,
    big: osz24_9_1366,

    cat: ["daytime", "elegant", "outdoor"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: osz24_10_360,
    med: osz24_10_600,
    big: osz24_10_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: osz24_11_360,
    med: osz24_11_600,
    big: osz24_11_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: osz24_19_360,
    med: osz24_19_600,
    big: osz24_19_1366,

    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: osz24_12_360,
    med: osz24_12_600,
    big: osz24_12_1366,

    cat: ["daytime", "historical", "outdoor"],
  },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: osz24_18_360,
    med: osz24_18_600,
    big: osz24_18_1366,

    cat: ["daytime", "elegant", "outdoor"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.3",
    small: osz24_13_360,
    med: osz24_13_600,
    big: osz24_13_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: osz24_15_360,
    med: osz24_15_600,
    big: osz24_15_1366,

    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: osz24_14_360,
    med: osz24_14_600,
    big: osz24_14_1366,

    cat: ["daytime", "historical", "outdoor"],
  },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: osz24_16_360,
    med: osz24_16_600,
    big: osz24_16_1366,

    cat: ["daytime", "elegant", "outdoor"],
  },

  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.2",
  //   small: osz24_20_360,
  //   med: osz24_20_600,
  //   big: osz24_20_1366,

  //   cat: ["daytime", "historical", "outdoor"],
  // },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.2",
  //   small: osz24_21_360,
  //   med: osz24_21_600,
  //   big: osz24_21_1366,

  //   cat: ["daytime", "historical", "outdoor"],
  // },
];
export let tel24 = [
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_01_360,
    med: tel24_01_600,
    big: tel24_01_1366,
    id: 1,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: tel24_09_360,
    med: tel24_09_600,
    big: tel24_09_1366,
    id: 9,

    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_40_360,
    med: tel24_40_600,
    big: tel24_40_1366,
    id: 40,

    cat: ["daytime", "historical", "outdoor", "drinks"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: tel24_03_360,
    med: tel24_03_600,
    big: tel24_03_1366,
    id: 3,

    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_04_360,
    med: tel24_04_600,
    big: tel24_04_1366,
    id: 4,

    cat: ["daytime", "elegant", "drinks", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_10_360,
    med: tel24_10_600,
    big: tel24_10_1366,

    id: 10,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    alt: "main1.gallery.alts.historical.2",
    small: tel24_05_360,
    med: tel24_05_600,
    big: tel24_05_1366,
    id: 5,

    cat: ["daytime", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: tel24_02_360,
    med: tel24_02_600,
    big: tel24_02_1366,
    id: 2,
    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    alt: "main1.gallery.alts.historical.1",
    small: tel24_06_360,
    med: tel24_06_600,
    big: tel24_06_1366,
    id: 6,

    cat: ["daytime", "outdoor"],
  },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.1",
  //   small: tel24_29_360,
  //   med: tel24_29_600,
  //   big: tel24_29_1366,
  //   id: 29,

  //   cat: ["daytime", "historical", "outdoor", "drinks"],
  // },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_07_360,
    med: tel24_07_600,
    big: tel24_07_1366,
    id: 7,

    cat: ["daytime", "elegant", "indoor"],
  },
  // {
  //   ship: "citadella",
  //   alt: "main1.gallery.alts.elegant.2",
  //   small: tel24_08_360,
  //   med: tel24_08_600,
  //   big: tel24_08_1366,
  //   id: 8,

  //   cat: ["daytime", "elegant", "drinks", "indoor"],
  // },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: tel24_36_360,
    med: tel24_36_600,
    big: tel24_36_1366,
    id: 36,

    cat: ["daytime", "elegant", "indoor", "drinks"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: tel24_11_360,
    med: tel24_11_600,
    big: tel24_11_1366,
    id: 11,

    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: tel24_12_360,
    med: tel24_12_600,
    big: tel24_12_1366,
    id: 12,

    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_13_360,
    med: tel24_13_600,
    big: tel24_13_1366,
    id: 13,

    cat: ["daytime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: tel24_14_360,
    med: tel24_14_600,
    big: tel24_14_1366,
    id: 14,

    cat: ["daytime", "elegant", "outdoor"],
  },
  // {
  //   ship: "citadella",
  //   alt: "main1.gallery.alts.elegant.3",
  //   small: tel24_15_360,
  //   med: tel24_15_600,
  //   big: tel24_15_1366,
  //   id: 15,

  //   cat: ["nighttime", "elegant", "outdoor"],
  // },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: tel24_24_360,
    med: tel24_24_600,
    big: tel24_24_1366,
    id: 24,

    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_16_360,
    id: 16,
    med: tel24_16_600,
    big: tel24_16_1366,

    cat: ["nighttime", "elegant", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: tel24_17_360,
    med: tel24_17_600,
    big: tel24_17_1366,
    id: 17,

    cat: ["nighttime", "elegant", "indoor"],
  },

  {
    alt: "main1.gallery.alts.historical.2",
    small: tel24_19_360,
    med: tel24_19_600,
    id: 19,
    big: tel24_19_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: tel24_20_360,
    med: tel24_20_600,
    big: tel24_20_1366,
    id: 20,

    cat: ["daytime", "elegant", "indoor", "drinks"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_76_360,
    med: tel24_76_600,
    id: 76,
    big: tel24_76_1366,

    cat: ["nighttime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_21_360,
    med: tel24_21_600,
    big: tel24_21_1366,
    id: 21,

    cat: ["daytime", "elegant", "indoor", "drinks"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: tel24_22_360,
    med: tel24_22_600,
    big: tel24_22_1366,
    id: 22,

    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_23_360,
    med: tel24_23_600,
    big: tel24_23_1366,
    id: 23,

    cat: ["daytime", "historical", "outdoor"],
  },
  // {
  //   ship: "citadella",
  //   alt: "main1.gallery.alts.elegant.3",
  //   small: tel24_37_360,
  //   med: tel24_37_600,
  //   id: 37,
  //   big: tel24_37_1366,

  //   cat: ["daytime", "elegant", "outdoor", "drinks"],
  // },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: tel24_25_360,
    med: tel24_25_600,
    big: tel24_25_1366,
    id: 25,

    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_26_360,
    med: tel24_26_600,
    big: tel24_26_1366,
    id: 26,

    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: tel24_33_360,
    med: tel24_33_600,
    big: tel24_33_1366,
    id: 33,

    cat: ["daytime", "historical", "outdoor", "drinks"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.2",
    small: tel24_27_360,
    med: tel24_27_600,
    big: tel24_27_1366,
    id: 27,

    cat: ["daytime", "elegant", "indoor", "drinks"],
  },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.2",
  //   small: tel24_44_360,
  //   med: tel24_44_600,
  //   big: tel24_44_1366,
  //   id: 44,

  //   cat: ["daytime", "historical", "outdoor", "drinks"],
  // },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.3",
    small: tel24_28_360,
    med: tel24_28_600,
    big: tel24_28_1366,
    id: 28,

    cat: ["nighttime", "elegant", "indoor"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: tel24_30_360,
    med: tel24_30_600,
    big: tel24_30_1366,
    id: 30,

    cat: ["daytime", "historical", "outdoor"],
  },

  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.1",
  //   small: tel24_32_360,
  //   med: tel24_32_600,
  //   big: tel24_32_1366,
  //   id: 32,

  //   cat: ["daytime", "historical", "outdoor", "drinks"],
  // },

  {
    alt: "main1.gallery.alts.elegant.3",
    small: tel24_34_360,
    med: tel24_34_600,
    big: tel24_34_1366,
    id: 34,

    cat: ["daytime", "outdoor"],
  },

  {
    alt: "main1.gallery.alts.historical.1",
    small: tel24_18_360,
    med: tel24_18_600,
    big: tel24_18_1366,
    id: 18,

    cat: ["daytime", "historical", "outdoor"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.3",
    small: tel24_39_360,
    med: tel24_39_600,
    big: tel24_39_1366,
    id: 39,

    cat: ["daytime", "historical", "outdoor"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.2",
    small: tel24_41_360,
    med: tel24_41_600,
    big: tel24_41_1366,
    id: 41,

    cat: ["daytime", "historical", "outdoor", "drinks"],
  },

  // {
  //   ship: "kisfaludy",
  //   alt: "main1.gallery.alts.historical.1",
  //   small: tel24_79_360,
  //   med: tel24_79_600,
  //   id: 79,
  //   big: tel24_79_1366,

  //   cat: ["nighttime", "historical", "outdoor"],
  // },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.3",
    small: tel24_31_360,
    med: tel24_31_600,
    big: tel24_31_1366,
    id: 31,

    cat: ["daytime", "historical", "outdoor", "drinks"],
  },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_50_360,
    med: tel24_50_600,
    big: tel24_50_1366,
    id: 50,

    cat: ["nighttime", "elegant", "indoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_51_360,
    med: tel24_51_600,
    big: tel24_51_1366,
    id: 51,

    cat: ["nighttime", "elegant", "outdoor"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_54_360,
    med: tel24_54_600,
    big: tel24_54_1366,
    id: 54,

    cat: ["nighttime", "historical", "outdoor"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_68_360,
    med: tel24_68_600,
    id: 68,
    big: tel24_68_1366,

    cat: ["daytime", "historical", "outdoor"],
  },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_66_360,
    med: tel24_66_600,
    id: 66,
    big: tel24_66_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  // {
  //   ship: "citadella",
  //   alt: "main1.gallery.alts.elegant.1",
  //   small: tel24_64_360,
  //   med: tel24_64_600,
  //   big: tel24_64_1366,
  //   id: 64,

  //   cat: ["nighttime", "elegant", "outdoor", "drinks"],
  // },

  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_80_360,
    med: tel24_80_600,
    id: 80,
    big: tel24_80_1366,

    cat: ["nighttime", "historical", "outdoor"],
  },
  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_74_360,
    med: tel24_74_600,
    id: 74,
    big: tel24_74_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  // {
  //   ship: "kisfaludy",
  //   alt: "main1.gallery.alts.historical.1",
  //   small: tel24_75_360,
  //   med: tel24_75_600,
  //   id: 75,
  //   big: tel24_75_1366,

  //   cat: ["nighttime", "historical", "outdoor"],
  // },

  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_77_360,
    med: tel24_77_600,
    id: 77,
    big: tel24_77_1366,

    cat: ["nighttime", "historical", "outdoor"],
  },
];
export let home = [
  // ...tel24,
  ...bestOf,
  {
    alt: "main1.gallery.alts.bar1",
    small: kftavasz2_360,
    med: kftavasz2_600,
    big: kftavasz2_1366,
    ship: "kisfaludy",
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    alt: "main1.gallery.alts.bar1",
    small: gal13_360,
    med: gal5_600,
    big: gal5_1366,
    ship: "kisfaludy",
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    alt: "main1.gallery.alts.bar1",
    small: tavasz45_360,
    med: tavasz45_600,
    big: tavasz45_1366,
    ship: "citadella",
    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.bar1",
    small: nyar_24_4_360,
    med: nyar_24_4_600,
    big: nyar_24_4_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    alt: "main1.gallery.alts.bar1",
    small: kftavasz4_360,
    med: kftavasz4_600,
    big: kftavasz4_1366,
    ship: "kisfaludy",
    cat: ["daytime", "historical", "outdoor", "drinks"],
  },
  {
    alt: "main1.gallery.alts.bar1",
    small: gal3_360,
    med: gal3_600,
    big: gal3_1366,
    pos: "70% 50%",
    cat: ["daytime", "elegant", "outdoor"],
    ship: "citadella",
  },
  {
    alt: "main1.gallery.alts.bar1",
    small: kftavasz5_360,
    med: kftavasz5_600,
    big: kftavasz5_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
    ship: "citadella",
  },

  {
    alt: "main1.gallery.alts.bar1",
    small: gal1_360,
    med: gal1_600,
    big: gal1_1366,
    pos: "50% 100%",
    cat: ["daytime", "elegant", "outdoor"],
    ship: "citadella",
  },
  {
    alt: "main1.gallery.alts.bar1",
    small: tavasz35_360,
    med: tavasz35_600,
    big: tavasz35_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
    ship: "citadella",
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.bar1",
    small: nyar_24_5_360,
    med: nyar_24_5_600,
    big: nyar_24_5_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    alt: "main1.gallery.alts.bar1",
    ship: "citadella",
    small: tavasz2_360,
    med: tavasz2_600,
    big: tavasz2_1366,
    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  {
    alt: "main1.gallery.alts.bar1",
    small: tavasz17_360,
    med: tavasz17_600,
    cat: ["daytime", "elegant", "outdoor"],
    ship: "citadella",
    big: tavasz17_1366,
  },

  {
    alt: "main1.gallery.alts.bar1",
    small: tavasz24_360,
    med: tavasz24_600,
    big: tavasz24_1366,
    ship: "citadella",
    cat: ["daytime", "elegant", "outdoor", "drinks"],
  },
  ...osz24,
];
export let bestOfWinter = [
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: ujgal11_360,
    med: ujgal11_600,
    big: ujgal11_1366,
    pos: "50% 90%",
    cat: ["daytime", "elegant", "outdoor"],
  },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.1",
  //   small: tel24_52_360,
  //   med: tel24_52_600,
  //   big: tel24_52_1366,

  //   cat: ["daytime", "historical", "outdoor", "drinks"],
  // },
  jan25[3],

  // {
  //   ship: "citadella",
  //   alt: "main1.gallery.alts.elegant.1",
  //   small: tel24_62_360,
  //   med: tel24_62_600,
  //   big: tel24_62_1366,
  //   id: 62,

  //   cat: ["nighttime", "elegant", "indoor", "drinks"],
  // },
  jan25[6],

  // {
  //   ship: "citadella",
  //   alt: "main1.gallery.alts.elegant.1",
  //   small: tel24_64_360,
  //   med: tel24_64_600,
  //   big: tel24_64_1366,
  //   id: 64,

  //   cat: ["nighttime", "elegant", "outdoor", "drinks"],
  // },

  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_66_360,
    med: tel24_66_600,
    id: 66,
    big: tel24_66_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_63_360,
    med: tel24_63_600,
    big: tel24_63_1366,
    id: 63,

    cat: ["daytime", "elegant", "indoor", "drinks"],
  },

  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_07_360,
    med: tel24_07_600,
    big: tel24_07_1366,

    cat: ["daytime", "elegant", "indoor"],
  },
  {
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
    small: tel24_23_360,
    med: tel24_23_600,
    big: tel24_23_1366,

    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_65_360,
    med: tel24_65_600,
    big: tel24_65_1366,
    id: 65,

    cat: ["nighttime", "elegant", "outdoor", "drinks"],
  },
  // {
  //   ship: "hableany",
  //   alt: "main1.gallery.alts.historical.2",
  //   small: tel24_44_360,
  //   med: tel24_44_600,
  //   big: tel24_44_1366,

  //   cat: ["daytime", "hisorical", "outdoor", "drinks"],
  // },

  {
    alt: "main1.gallery.alts.elegant.2",
    small: tel24_47_360,
    med: tel24_47_600,
    big: tel24_47_1366,

    cat: ["daytime", "outdoor"],
  },
  jan25[4],
  // {
  //   ship: "citadella",
  //   alt: "main1.gallery.alts.elegant.3",
  //   small: tel24_45_360,
  //   med: tel24_45_600,
  //   big: tel24_45_1366,

  //   cat: ["daytime", "elegant", "indoor", "drinks"],
  // },

  {
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.2",
    small: random2_360,
    med: random2_600,
    big: random2_1366,
    pos: "50% 70%",
    cat: ["daytime", "historical", "outdoor"],
  },
  {
    ship: "citadella",
    alt: "main1.gallery.alts.elegant.1",
    small: tel24_51_360,
    med: tel24_51_600,
    big: tel24_51_1366,

    cat: ["nighttime", "elegant", "outdoor"],
  },
];

function Gallery(props) {
  const [width, setWidth] = useState(window.innerWidth);
  const [currentImg, setCurrentImg] = useState(bestOfWinter[0]);
  const { lang } = props;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: "#gallery",
      children: "b",
      showHideAnimationType: "zoom",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);
  const { t } = useTranslation();

  const mappedDrinks = drinks.map((e, i) => {
    return (
      <SwiperSlide key={i}>
        <img
          loading="lazy"
          src={width <= 380 ? e.small : width <= 1000 ? e.med : e.big}
          alt={t([e.alt, "main1.gallery.alts.fallback"])}
          className="img-container-drinks"
          style={{
            objectFit: "cover",
            height: "100%",
            width: "100%",
            minHeight: "100%",
            minWidth: "100%",
          }}
        />
      </SwiperSlide>
    );
  });
  const mappedHome = bestOf.slice(0, 10).map((e, i) => {
    return (
      <SwiperSlide style={{ position: "relative" }} key={i}>
        <img
          onClick={() => {
            setCurrentImg(e);
          }}
          loading="lazy"
          src={width <= 380 ? e.small : width <= 1600 ? e.med : e.big}
          alt={t([e.alt, "main1.gallery.alts.fallback"])}
          className={`img-container-home ${e === currentImg ? "" : "inactive"} ${
            e.ship ? e.ship : ""
          }`}
          style={{
            objectFit: "cover",
            width: "100%",
            minHeight: "100%",
            minWidth: "100%",
            objectPosition: e.pos ?? e.pos,
          }}
        />
        <div className={`filter ${e === currentImg ? "hidden" : ""}`}></div>
      </SwiperSlide>
    );
  });
  useEffect(() => {
    let isMounted = true;
    window.addEventListener("resize", () => {
      if (isMounted) setWidth(window.innerWidth);
    });

    return () => {
      isMounted = false;
      window.removeEventListener("resize", () => setWidth(window.innerWidth));
    };
  }, []);
  const getImgs = (path) => {
    const elements = document.querySelectorAll(`.${path} .swiper-slide-visible`);
    if (elements.length > 0 && elements[elements.length - 1].nextSibling) {
      elements.forEach((e) => e.children[0].setAttribute("loading", "eager"));
      elements.forEach((e) => {
        if (e.nextSibling) {
          e.nextSibling.children[0].setAttribute("loading", "eager");
        }
      });
      // elements[elements.length - 1].nextSibling.children[0].setAttribute("loading", "eager");
    }
  };
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
  });
  return (
    <section ref={ref} id={props.name === "Homepage" ? "gallery" : "bar-gallery"}>
      {props.name === "Homepage" ? (
        <div>
          {/* <div className="gallery-head-wrap">
            <div className="gold-dot"></div>
            <div className="gallery-header">
              <h2>{t("Partials.Header.gallery")}</h2>
            </div>
            <div className="gold-dot"></div>
          </div> */}

          {width < 800 ? (
            <div className="home-gallery-wrap">
              <Swiper
                onSlideChange={() => getImgs("home-gallery-wrap")}
                watchSlidesProgress
                pagination={{ clickable: true }}
                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                modules={[Navigation, Pagination, Autoplay, Thumbs]}
                slidesPerView={
                  width <= 500
                    ? 1
                    : width > 500 && width <= 750
                    ? 1.5
                    : width < 1100
                    ? 2
                    : width > 1600
                    ? 4
                    : 3
                }
                autoplay={
                  inView
                    ? {
                        delay: 6000,
                        disableOnInteraction: true,
                      }
                    : {}
                }
                centeredSlides
                speed={600}
                spaceBetween={10}
                navigation
                initialSlide={0}
                loop>
                {mappedHome}
              </Swiper>

              <Swiper
                onSwiper={setThumbsSwiper}
                onSlideChange={() => getImgs("home-gallery-thumbs")}
                spaceBetween={10}
                slidesPerView={width <= 450 ? Math.round(width / 100) : Math.round(width / 150)}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="thumbSwiper">
                {mappedHome}
              </Swiper>
            </div>
          ) : (
            <div className="gallery-bg">
              <div className="bg"></div>
              <div
                className="bg-img"
                style={{
                  backgroundImage: `url(${currentImg.big})`,
                  backgroundPosition: currentImg.pos ? currentImg.pos : "center",
                }}></div>
              <div className="home-gallery-wrap desktop">
                <div className="main-img">
                  <img
                    src={currentImg.big}
                    alt={t([currentImg.alt, "main1.gallery.alts.fallback"])}
                    style={currentImg.pos ? { objectPosition: currentImg.pos } : {}}
                  />
                </div>

                <div className="imgs-grid">
                  {bestOf.slice(0, 9).map((e, i) => (
                    <div
                      className="img-wrap"
                      key={i}
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                      }}>
                      <img
                        onClick={() => {
                          setCurrentImg(e);
                        }}
                        src={e.small}
                        alt={t([e.alt, "main1.gallery.alts.fallback"])}
                        style={e.pos ? { objectPosition: e.pos } : {}}
                        className={`${e === currentImg ? "active" : ""}`}
                      />
                      <div className={`filter ${e === currentImg ? "hidden" : ""}`}></div>
                    </div>
                  ))}
                  <div className="btn-wrap desktop">
                    <div className="bttn dark gold-bg">
                      <Link id={`clickto-home-gallery-page`} to={`gallery`}>
                        <span>{t("main1.gallery.h")}</span>
                        <div className="arr"></div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="btn-wrap mobile">
            {/* <div className="bttn vr dark">
              <Link id={`clickto-home-vr`} to={`/${lang}/vrtour-citadella`}>
                <span>{t("main1.vr.h")}</span>
                <div className="eye"></div>
              </Link>
            </div> */}

            <div className="bttn dark gold-bg">
              <Link id={`clickto-home-gallery-page`} to={`gallery`}>
                <span>{t("main1.gallery.more")}</span>
                <div className="arr"></div>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="drinks-gallery-wrap">
          <Swiper
            watchSlidesProgress
            onSlideChange={() => getImgs("drinks-gallery-wrap")}
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={1}
            autoplay={inView ? { delay: 6000, disableOnInteraction: true } : {}}
            speed={600}
            navigation
            centeredSlides
            loop>
            {mappedDrinks}
          </Swiper>
        </div>
      )}
    </section>
  );
}

export default Gallery;
